export const matchSamples = [
  {
    id: 0,
    name: "Let's play chess",
    accuracyPercentage: 0.7391304347826086,
    recallPercentage: 0.5,
    precisionPercentage: 0.16666666666666666,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: 'Kings Pawn opening.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e5',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/3PP3/8/PPP2PPP/RNBQKBNR',
        comment: 'Centre Counter',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 3,
        moveFrom: 'e5',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'd1',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppp1ppp/8/8/3QP3/8/PPP2PPP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'b8',
        moveTo: 'c6',
        fen: 'r1bqkbnr/pppp1ppp/2n5/8/3QP3/8/PPP2PPP/RNB1KBNR',
        comment: "Developing at the queen's expense.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'd4',
        moveTo: 'e3',
        fen: 'r1bqkbnr/pppp1ppp/2n5/8/4P3/4Q3/PPP2PPP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'r1bqkb1r/pppp1ppp/2n2n2/8/4P3/4Q3/PPP2PPP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'f2',
        moveTo: 'f3',
        fen: 'r1bqkb1r/pppp1ppp/2n2n2/8/4P3/4QP2/PPP3PP/RNB1KBNR',
        comment:
          'Maybe it was better to avoid weakening the kingside and to defend the pawn with Nc3 or Bd3. This has the added bonus of developing.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'f8',
        moveTo: 'e7',
        fen: 'r1bqk2r/ppppbppp/2n2n2/8/4P3/4QP2/PPP3PP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 10,
        moveFrom: 'c2',
        moveTo: 'c3',
        fen: 'r1bqk2r/ppppbppp/2n2n2/8/4P3/2P1QP2/PP4PP/RNB1KBNR',
        comment: 'Falling further behind in development. This square belongs to the knight.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 11,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'r1bq1rk1/ppppbppp/2n2n2/8/4P3/2P1QP2/PP4PP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'g2',
        moveTo: 'g3',
        fen: 'r1bq1rk1/ppppbppp/2n2n2/8/4P3/2P1QPP1/PP5P/RNB1KBNR',
        comment:
          'Still refusing to develop, and this will prove diastrous if black manages to open up the game quickly, which I did.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'f8',
        moveTo: 'e8',
        fen: 'r1bqr1k1/ppppbppp/2n2n2/8/4P3/2P1QPP1/PP5P/RNB1KBNR',
        comment:
          'Creating the threat of d5. The queen and king being on the same file allows some tactical ideas.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'f1',
        moveTo: 'h3',
        fen: 'r1bqr1k1/ppppbppp/2n2n2/8/4P3/2P1QPPB/PP5P/RNB1K1NR',
        comment: 'Finally developing a piece, but it may already be too late.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'd7',
        moveTo: 'd5',
        fen: 'r1bqr1k1/ppp1bppp/2n2n2/3p4/4P3/2P1QPPB/PP5P/RNB1K1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 16,
        moveFrom: 'e4',
        moveTo: 'e5',
        fen: 'r1bqr1k1/ppp1bppp/2n2n2/3pP3/8/2P1QPPB/PP5P/RNB1K1NR',
        comment: 'Falling for the trick. Nd2 trying to holsd the pawn would have been better.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 17,
        moveFrom: 'c6',
        moveTo: 'e5',
        fen: 'r1bqr1k1/ppp1bppp/5n2/3pn3/8/2P1QPPB/PP5P/RNB1K1NR',
        comment: 'Due to the potential king and queen pin, the knight shouldnt be taken.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'h3',
        moveTo: 'c8',
        fen: 'r1Bqr1k1/ppp1bppp/5n2/3pn3/8/2P1QPP1/PP5P/RNB1K1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'd8',
        moveTo: 'c8',
        fen: 'r1q1r1k1/ppp1bppp/5n2/3pn3/8/2P1QPP1/PP5P/RNB1K1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 20,
        moveFrom: 'g1',
        moveTo: 'e2',
        fen: 'r1q1r1k1/ppp1bppp/5n2/3pn3/8/2P1QPP1/PP2N2P/RNB1K2R',
        comment:
          'After the tactical skirmish, black is only a pawn up, but his supeior development and the activity of the pieces virtually guarantee a win.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 21,
        moveFrom: 'e5',
        moveTo: 'c4',
        fen: 'r1q1r1k1/ppp1bppp/5n2/3p4/2n5/2P1QPP1/PP2N2P/RNB1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'e3',
        moveTo: 'd3',
        fen: 'r1q1r1k1/ppp1bppp/5n2/3p4/2n5/2PQ1PP1/PP2N2P/RNB1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'e7',
        moveTo: 'c5',
        fen: 'r1q1r1k1/ppp2ppp/5n2/2bp4/2n5/2PQ1PP1/PP2N2P/RNB1K2R',
        comment:
          'Preventing the king from castling as well as eying up some some nice squares in the white camp.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'b1',
        moveTo: 'a3',
        fen: 'r1q1r1k1/ppp2ppp/5n2/2bp4/2n5/N1PQ1PP1/PP2N2P/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'c4',
        moveTo: 'e3',
        fen: 'r1q1r1k1/ppp2ppp/5n2/2bp4/8/N1PQnPP1/PP2N2P/R1B1K2R',
        comment: 'Penetrating the white camp.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'c1',
        moveTo: 'e3',
        fen: 'r1q1r1k1/ppp2ppp/5n2/2bp4/8/N1PQBPP1/PP2N2P/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'e8',
        moveTo: 'e3',
        fen: 'r1q3k1/ppp2ppp/5n2/2bp4/8/N1PQrPP1/PP2N2P/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'd3',
        moveTo: 'd2',
        fen: 'r1q3k1/ppp2ppp/5n2/2bp4/8/N1P1rPP1/PP1QN2P/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'c8',
        moveTo: 'e6',
        fen: 'r5k1/ppp2ppp/4qn2/2bp4/8/N1P1rPP1/PP1QN2P/R3K2R',
        comment: 'White cant castle as the knight on e2 will fall.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'a3',
        moveTo: 'c2',
        fen: 'r5k1/ppp2ppp/4qn2/2bp4/8/2P1rPP1/PPNQN2P/R3K2R',
        comment: 'Trying to force the rook away.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'e3',
        moveTo: 'e5',
        fen: 'r5k1/ppp2ppp/4qn2/2bpr3/8/2P2PP1/PPNQN2P/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'f3',
        moveTo: 'f4',
        fen: 'r5k1/ppp2ppp/4qn2/2bpr3/5P2/2P3P1/PPNQN2P/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'e5',
        moveTo: 'e4',
        fen: 'r5k1/ppp2ppp/4qn2/2bp4/4rP2/2P3P1/PPNQN2P/R3K2R',
        comment: 'But it still has this square where it cant be touched.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'h2',
        moveTo: 'h3',
        fen: 'r5k1/ppp2ppp/4qn2/2bp4/4rP2/2P3PP/PPNQN3/R3K2R',
        comment:
          'White has been reduced to total passiveness, and black has as much time as he wants to try and finish the game off.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'a8',
        moveTo: 'e8',
        fen: '4r1k1/ppp2ppp/4qn2/2bp4/4rP2/2P3PP/PPNQN3/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 36,
        moveFrom: 'h1',
        moveTo: 'h2',
        fen: '4r1k1/ppp2ppp/4qn2/2bp4/4rP2/2P3PP/PPNQN2R/R3K3',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 37,
        moveFrom: 'f6',
        moveTo: 'h5',
        fen: '4r1k1/ppp2ppp/4q3/2bp3n/4rP2/2P3PP/PPNQN2R/R3K3',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 38,
        moveFrom: 'e1',
        moveTo: 'c1',
        fen: '4r1k1/ppp2ppp/4q3/2bp3n/4rP2/2P3PP/PPNQN2R/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'e4',
        moveTo: 'e2',
        fen: '4r1k1/ppp2ppp/4q3/2bp3n/5P2/2P3PP/PPNQr2R/2KR4',
        comment: 'Free knight.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'h2',
        moveTo: 'e2',
        fen: '4r1k1/ppp2ppp/4q3/2bp3n/5P2/2P3PP/PPNQR3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'e6',
        moveTo: 'e2',
        fen: '4r1k1/ppp2ppp/8/2bp3n/5P2/2P3PP/PPNQq3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'd2',
        moveTo: 'd5',
        fen: '4r1k1/ppp2ppp/8/2bQ3n/5P2/2P3PP/PPN1q3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 43,
        moveFrom: 'c5',
        moveTo: 'e3',
        fen: '4r1k1/ppp2ppp/8/3Q3n/5P2/2P1b1PP/PPN1q3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'c2',
        moveTo: 'e3',
        fen: '4r1k1/ppp2ppp/8/3Q3n/5P2/2P1N1PP/PP2q3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'e2',
        moveTo: 'e3',
        fen: '4r1k1/ppp2ppp/8/3Q3n/5P2/2P1q1PP/PP6/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 46,
        moveFrom: 'c1',
        moveTo: 'b1',
        fen: '4r1k1/ppp2ppp/8/3Q3n/5P2/2P1q1PP/PP6/1K1R4',
        comment:
          'Black still has to be careful as swapping the queens with Qe4  allows Qxe4 and Rd8, mating.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 47,
        moveFrom: 'h5',
        moveTo: 'g3',
        fen: '4r1k1/ppp2ppp/8/3Q4/5P2/2P1q1nP/PP6/1K1R4',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 48,
        moveFrom: 'd5',
        moveTo: 'd7',
        fen: '4r1k1/pppQ1ppp/8/8/5P2/2P1q1nP/PP6/1K1R4',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 49,
        moveFrom: 'g3',
        moveTo: 'e2',
        fen: '4r1k1/pppQ1ppp/8/8/5P2/2P1q2P/PP2n3/1K1R4',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 50,
        moveFrom: 'd7',
        moveTo: 'd8',
        fen: '3Qr1k1/ppp2ppp/8/8/5P2/2P1q2P/PP2n3/1K1R4',
        comment: 'Cheeky trap.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 51,
        moveFrom: 'e3',
        moveTo: 'c1',
        fen: '3Qr1k1/ppp2ppp/8/8/5P2/2P4P/PP2n3/1KqR4',
        comment: 'This tactic swaps queens without allowing a mate.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'd1',
        moveTo: 'c1',
        fen: '3Qr1k1/ppp2ppp/8/8/5P2/2P4P/PP2n3/1KR5',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 53,
        moveFrom: 'e8',
        moveTo: 'd8',
        fen: '3r2k1/ppp2ppp/8/8/5P2/2P4P/PP2n3/1KR5',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 54,
        moveFrom: 'b1',
        moveTo: 'c2',
        fen: '3r2k1/ppp2ppp/8/8/5P2/2P4P/PPK1n3/2R5',
        comment: 'The rest of the game is fairly easy, and there is no need for annotation.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 55,
        moveFrom: 'e2',
        moveTo: 'f4',
        fen: '3r2k1/ppp2ppp/8/8/5n2/2P4P/PPK5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'h3',
        moveTo: 'h4',
        fen: '3r2k1/ppp2ppp/8/8/5n1P/2P5/PPK5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'f7',
        moveTo: 'f6',
        fen: '3r2k1/ppp3pp/5p2/8/5n1P/2P5/PPK5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'b2',
        moveTo: 'b4',
        fen: '3r2k1/ppp3pp/5p2/8/1P3n1P/2P5/P1K5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'g8',
        moveTo: 'f7',
        fen: '3r4/ppp2kpp/5p2/8/1P3n1P/2P5/P1K5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 60,
        moveFrom: 'a2',
        moveTo: 'a4',
        fen: '3r4/ppp2kpp/5p2/8/PP3n1P/2P5/2K5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'g7',
        moveTo: 'g5',
        fen: '3r4/ppp2k1p/5p2/6p1/PP3n1P/2P5/2K5/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'c1',
        moveTo: 'f1',
        fen: '3r4/ppp2k1p/5p2/6p1/PP3n1P/2P5/2K5/5R2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'f7',
        moveTo: 'g6',
        fen: '3r4/ppp4p/5pk1/6p1/PP3n1P/2P5/2K5/5R2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 64,
        moveFrom: 'f1',
        moveTo: 'g1',
        fen: '3r4/ppp4p/5pk1/6p1/PP3n1P/2P5/2K5/6R1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 65,
        moveFrom: 'h7',
        moveTo: 'h5',
        fen: '3r4/ppp5/5pk1/6pp/PP3n1P/2P5/2K5/6R1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 66,
        moveFrom: 'c2',
        moveTo: 'b3',
        fen: '3r4/ppp5/5pk1/6pp/PP3n1P/1KP5/8/6R1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'g5',
        moveTo: 'g4',
        fen: '3r4/ppp5/5pk1/7p/PP3npP/1KP5/8/6R1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 68,
        moveFrom: 'a4',
        moveTo: 'a5',
        fen: '3r4/ppp5/5pk1/P6p/1P3npP/1KP5/8/6R1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'f4',
        moveTo: 'h3',
        fen: '3r4/ppp5/5pk1/P6p/1P4pP/1KP4n/8/6R1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'g1',
        moveTo: 'g2',
        fen: '3r4/ppp5/5pk1/P6p/1P4pP/1KP4n/6R1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 71,
        moveFrom: 'f6',
        moveTo: 'f5',
        fen: '3r4/ppp5/6k1/P4p1p/1P4pP/1KP4n/6R1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 72,
        moveFrom: 'b4',
        moveTo: 'b5',
        fen: '3r4/ppp5/6k1/PP3p1p/6pP/1KP4n/6R1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 73,
        moveFrom: 'f5',
        moveTo: 'f4',
        fen: '3r4/ppp5/6k1/PP5p/5ppP/1KP4n/6R1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 74,
        moveFrom: 'g2',
        moveTo: 'e2',
        fen: '3r4/ppp5/6k1/PP5p/5ppP/1KP4n/4R3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 75,
        moveFrom: 'g6',
        moveTo: 'f6',
        fen: '3r4/ppp5/5k2/PP5p/5ppP/1KP4n/4R3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 76,
        moveFrom: 'c3',
        moveTo: 'c4',
        fen: '3r4/ppp5/5k2/PP5p/2P2ppP/1K5n/4R3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 77,
        moveFrom: 'f4',
        moveTo: 'f3',
        fen: '3r4/ppp5/5k2/PP5p/2P3pP/1K3p1n/4R3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 78,
        moveFrom: 'e2',
        moveTo: 'e1',
        fen: '3r4/ppp5/5k2/PP5p/2P3pP/1K3p1n/8/4R3',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 79,
        moveFrom: 'f3',
        moveTo: 'f2',
        fen: '3r4/ppp5/5k2/PP5p/2P3pP/1K5n/5p2/4R3',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 80,
        moveFrom: 'e1',
        moveTo: 'c1',
        fen: '3r4/ppp5/5k2/PP5p/2P3pP/1K5n/5p2/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 81,
        moveFrom: 'g4',
        moveTo: 'g3',
        fen: '3r4/ppp5/5k2/PP5p/2P4P/1K4pn/5p2/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 82,
        moveFrom: 'c4',
        moveTo: 'c5',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1K4pn/5p2/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 83,
        moveFrom: 'g3',
        moveTo: 'g2',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1K5n/5pp1/2R5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 84,
        moveFrom: 'c1',
        moveTo: 'c3',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1KR4n/5pp1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 85,
        moveFrom: 'f2',
        moveTo: 'f1q',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1KR4n/6p1/5q2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 86,
        moveFrom: 'c3',
        moveTo: 'h3',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1K5R/6p1/5q2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 87,
        moveFrom: 'g2',
        moveTo: 'g1q',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1K5R/8/5qq1',
        comment: 'Two queens up!',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 88,
        moveFrom: 'h3',
        moveTo: 'c3',
        fen: '3r4/ppp5/5k2/PPP4p/7P/1KR5/8/5qq1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 89,
        moveFrom: 'f1',
        moveTo: 'b5',
        fen: '3r4/ppp5/5k2/PqP4p/7P/1KR5/8/6q1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 90,
        moveFrom: 'b3',
        moveTo: 'c2',
        fen: '3r4/ppp5/5k2/PqP4p/7P/2R5/2K5/6q1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 91,
        moveFrom: 'g1',
        moveTo: 'b1',
        fen: '3r4/ppp5/5k2/PqP4p/7P/2R5/2K5/1q6',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
    ],
  },
  {
    id: 1,
    name: 'Final Round of LA Open',
    accuracyPercentage: 0.7241379310344828,
    recallPercentage: 0.6666666666666666,
    precisionPercentage: 0.5454545454545454,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment:
          "My game with this 80-year old guy is an excellent example of how a simple lead in development can totally annihilate your opponent's king.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e5',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
        comment:
          'In double king pawn positions, and other open games, development is the most important thing.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/3PP3/8/PPP2PPP/RNBQKBNR',
        comment:
          "Instead of playing Nf3 like normal, I decided to see if this old guy knew the importance of development, by playing this risky opening that can crush someone (like Mr. Vinecour) or anyone else who isn't familiar with it. But if Black knows what to do against this opening, then it really isn't dangerous.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'e5',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR',
        comment: 'Not taking the pawn leads to very boring positions.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 4,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbqkbnr/pppp1ppp/8/8/3pP3/5N2/PPP2PPP/RNBQKB1R',
        comment:
          "Taking the pawn will lose a tempo to an eventual Nc6 attack on the queen.  Instead I develop another piece while I test this old guy's knowledge of development. If he's smart, he'll know not to try and hold the d4-pawn.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 5,
        moveFrom: 'c7',
        moveTo: 'c5',
        fen: 'rnbqkbnr/pp1p1ppp/8/2p5/3pP3/5N2/PPP2PPP/RNBQKB1R',
        comment:
          "Apparently this guy hasn't learned the importance of development in his alleged 70 years of playing. Although Black is winning a pawn, c5 is a serious weakening move since Black can no longer play the defensive c6, and Black is neglecting his development, allowing me to gain more. For those of you who know this opening, you know that 3...d5 is a much stronger move by Black.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 6,
        moveFrom: 'c2',
        moveTo: 'c3',
        fen: 'rnbqkbnr/pp1p1ppp/8/2p5/3pP3/2P2N2/PP3PPP/RNBQKB1R',
        comment: 'The sacrifice for development.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 7,
        moveFrom: 'd4',
        moveTo: 'c3',
        fen: 'rnbqkbnr/pp1p1ppp/8/2p5/4P3/2p2N2/PP3PPP/RNBQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqkbnr/pp1p1ppp/8/2p5/4P3/2N2N2/PP3PPP/R1BQKB1R',
        comment:
          "This gambit is a lot like the dubious Danish Gambit (e4 e5 d4 exd4 c3) except that Black has played c5, which makes a HUGE difference. Because in the Danish Gambit, Black can hold onto his extra pawn by playing c6 securing a solid position, but now Black's position will fall apart due to this weakness. His d-pawn is backward and I have strong control of the d-file. I'm also ahead in development.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'd7',
        moveTo: 'd6',
        fen: 'rnbqkbnr/pp3ppp/3p4/2p5/4P3/2N2N2/PP3PPP/R1BQKB1R',
        comment:
          "This is the only good square for Black's backward pawn. Notice how Black has a hard time finding good squares for his undeveloped pieces, while I'm developing strong and have lots of active squares for my pieces to develop in the future. This is because I was developing while Black was greedily holding onto a measly pawn.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnbqkbnr/pp3ppp/3p4/2p5/2B1P3/2N2N2/PP3PPP/R1BQK2R',
        comment:
          'I have such strong piece play in the centre. If Black plays correctly, then the game will reach ultra-complicated positions where I must use my development initiative to crush his passive position. All it takes is one inaccurate or pointless move by Black and he will be totally lost.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'rnbqkbnr/pp3pp1/3p3p/2p5/2B1P3/2N2N2/PP3PPP/R1BQK2R',
        comment:
          "There it is, the inaccurate move. Black is too worried about me playing Ng5 (which isn't a dangerous threat) and makes a losing move. Black has no idea what the importance of development is, otherwise he would've played a move like Be7, which stops Ng5, while also DEVELOPING a piece. I searched for this position on the Gameknot database, and not one of the 7 players who've had this position found my next winning move.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'c4',
        moveTo: 'f7',
        fen: 'rnbqkbnr/pp3Bp1/3p3p/2p5/4P3/2N2N2/PP3PPP/R1BQK2R',
        comment:
          "I can afford to sacrifice this piece, because I have strong piece play in the centre, while Black's extra piece will be sitting passively undeveloped on the back rank. However, after this sacrifice, I must be extremely careful to play tactically correct, or else Black may find a way out of my attack and hold onto his extra material.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'e8',
        moveTo: 'f7',
        fen: 'rnbq1bnr/pp3kp1/3p3p/2p5/4P3/2N2N2/PP3PPP/R1BQK2R',
        comment:
          "Accepting the sacrifice is totally losing. Black's only chance was to not take the bishop. Material would be even, but it would take longer for me to rip open Black's passive position. Black probably thought his only chance was to try to hold onto his extra piece, but he is sadly mistaken.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'f3',
        moveTo: 'e5',
        fen: 'rnbq1bnr/pp3kp1/3p3p/2p1N3/4P3/2N5/PP3PPP/R1BQK2R',
        comment:
          "My queen's domination of the d-file and the fact that White's undeveloped pieces block the rook from protecting his queen are what make my move possible.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'f7',
        moveTo: 'f6',
        fen: 'rnbq1bnr/pp4p1/3p1k1p/2p1N3/4P3/2N5/PP3PPP/R1BQK2R',
        comment:
          "The king cannot go back to e8 because I will play Qh5 check, followed by mate on f7. If Black played Ke7, then I can fork the king and rook with Ng6, and I'll be up the exchange. (His rook for my bishop).  And 8...Ke6 is also losing because of 9.Qd5  Kf6 (Ke7 Qf7#) 10.Qf7  Kxe5 11.Bf4  Kd4 12.Qd5#  Black's best chance was to just simply give me the exchange, which avoids immediate mate.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 16,
        moveFrom: 'd1',
        moveTo: 'f3',
        fen: 'rnbq1bnr/pp4p1/3p1k1p/2p1N3/4P3/2N2Q2/PP3PPP/R1B1K2R',
        comment:
          "You may think I'm crazy for sacrificing my e5 knight when I'm already down a bishop, but White's last moves are pretty much forced, and his two extra pieces haven't even moved yet. Also, sacrificing a second piece is the only way I can win this position.",
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 17,
        moveFrom: 'f6',
        moveTo: 'e5',
        fen: 'rnbq1bnr/pp4p1/3p3p/2p1k3/4P3/2N2Q2/PP3PPP/R1B1K2R',
        comment:
          'Forced, since the other two moves get mated.    Ke6: 10. Qf7  Kxe5 11. f4  Kd4 12. Qd5#  Ke7: 10. Qf7#',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'f3',
        moveTo: 'f7',
        fen: 'rnbq1bnr/pp3Qp1/3p3p/2p1k3/4P3/2N5/PP3PPP/R1B1K2R',
        comment:
          "Here I am cutting off the king's escape square e6, and I am also threatening to play Bf4  with Qd5 mate to follow. Although my win is completely forced, please note that I did NOT calculate the final mating position on move 16 when I played Bxf7. Once I calculated up to this position from move 7, I couldn't calculate anymore, and I knew there had to be a forced mate somewhere, because my pieces have easy access to Black's humorously exposed king, and also Black has absolutely no counterplay in his underdeveloped position.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 19,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rnbq1b1r/pp3Qp1/3p1n1p/2p1k3/4P3/2N5/PP3PPP/R1B1K2R',
        comment:
          "This is Black's only move that stops my checkmating threat of f4  then Qd5# and g5 or Qh4 don't stop it since after f4  I can simply replace the pawn with my bishop. But Black is only further prolonging the mate, because whenever there's a centralized king on an open board, which is surrounded by enemy pieces, there is almost always a forced mate.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'f2',
        moveTo: 'f4',
        fen: 'rnbq1b1r/pp3Qp1/3p1n1p/2p1k3/4PP2/2N5/PP4PP/R1B1K2R',
        comment:
          "I have taken away another square from White's king, drawing him further into my territory.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'e5',
        moveTo: 'd4',
        fen: 'rnbq1b1r/pp3Qp1/3p1n1p/2p5/3kPP2/2N5/PP4PP/R1B1K2R',
        comment:
          "I sacrificed my pawn on e5 because I didn't want White to play c5 and retreat his king to c4 where it would've been safe.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'c3',
        moveTo: 'e2',
        fen: 'rnbq1b1r/pp3Qp1/3p1n1p/2p5/3kPP2/8/PP2N1PP/R1B1K2R',
        comment:
          'This is a very important move, because if I get too hasty in trying to mate Black, then he can play c4 and escape to c5 where he safeguards his king and I will be down two pieces for nothing. Ne2  draws the king to a square where his only escape path will also get him mated.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 23,
        moveFrom: 'd4',
        moveTo: 'e4',
        fen: 'rnbq1b1r/pp3Qp1/3p1n1p/2p5/4kP2/8/PP2N1PP/R1B1K2R',
        comment: 'Kd3 was the only other move, but also gets mated by Qb3  Kxe4 Ng3  Kd4 Be3#.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'rnbq1b1r/pp3Qp1/3p1n1p/2p5/4kP2/8/PP2N1PP/R1B2RK1',
        comment:
          "All I need now is another piece in play to finish off the exposed king. With my rook accessible to the open centre files, White will soon be mated if he doesn't move his king (like in the game). And there is also a forced mate in 7 waiting for Black if he tries to escape with his king. Mate is inevitable.",
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 25,
        moveFrom: 'd8',
        moveTo: 'e7',
        fen: 'rnb2b1r/pp2qQp1/3p1n1p/2p5/4kP2/8/PP2N1PP/R1B2RK1',
        comment:
          "Black plays a passive move and allows my immediate mate in 3. If Black had tried escaping with Kf5, then I have (Ng3  Kg4 Qg6  Kh4 Nf5  Bxf5 g3  Kh3 Qxf5  Ng4 Qh5  Qh4 Qxh4#)  I've calculated a lot of possible mating sequences in this annotation, as a result of Black's exposed king and his lack of developed defenders.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'e2',
        moveTo: 'g3',
        fen: 'rnb2b1r/pp2qQp1/3p1n1p/2p5/4kP2/6N1/PP4PP/R1B2RK1',
        comment: 'The first move in my mate in 3 attack.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'e4',
        moveTo: 'd3',
        fen: 'rnb2b1r/pp2qQp1/3p1n1p/2p5/5P2/3k2N1/PP4PP/R1B2RK1',
        comment: 'Kd4 gets mated immediately with Rd1#',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'f1',
        moveTo: 'd1',
        fen: 'rnb2b1r/pp2qQp1/3p1n1p/2p5/5P2/3k2N1/PP4PP/R1BR2K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'd3',
        moveTo: 'c2',
        fen: 'rnb2b1r/pp2qQp1/3p1n1p/2p5/5P2/6N1/PPk3PP/R1BR2K1',
        comment:
          "Just look at Black's helpless king in my territory that's about to get mated, and Black's undeveloped pieces in his own territory can't do anything. Development played a big role in my game.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'd1',
        moveTo: 'd2',
        fen: 'rnb2b1r/pp2qQp1/3p1n1p/2p5/5P2/6N1/PPkR2PP/R1B3K1',
        comment:
          "This mate is slightly nicer looking than my other choice of Qb3#  Hopefully Black learned a valuable lesson from my crushing attack.  Develop as quickly as possible, don't waste tempo with pointless moves like h6, and don't waste moves holding onto 'free' pawns!",
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 2,
    name: 'Quarter Final Candidates Match, Italy 1977',
    accuracyPercentage: 0.8032786885245902,
    recallPercentage: 1,
    precisionPercentage: 0.07692307692307693,
    plays: [
      {
        id: 0,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment:
          'A Petrosian patent. Most if not all of Petrosians chess games as white are opened with either d4 or c4. However, just for the beginners out there it is important to note that neither e4, d4 nor c4 (and Nf3 and g3) are all equal openings with neither one being more effective than the other. It is only a matter of preference.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'd7',
        moveTo: 'd5',
        fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR',
        comment:
          "Korchnoi responds with d5 which is slightly odd for his style of play as most of the time (86% of the time in fact) Korchnoi replies to 1.d4 with Nf6 and either a Gruenfeld or an Indian. So with d5 Korchnoi might have something prepared...   On 1...d5 Black is simply mimicking white's move. This can lead to the many variations in the Queens Gambit Declined such as the Slav, Tarrasch, Semi-Tarrasch Defence as well as the Torre Attack and other uncommon opening variations. It is a perfectly logical and playable move.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R',
        comment: 'Less common then c4 but perfectly playable.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R',
        comment:
          'Once again mimicking whites move. White now has two main choices c4 which leads to the QGD or Bg5 which may become a Torre Attack depending on other moves played.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'c2',
        moveTo: 'c4',
        fen: 'rnbqkb1r/ppp1pppp/5n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 5,
        moveFrom: 'e7',
        moveTo: 'e6',
        fen: 'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R',
        comment:
          "Accepting the 'gambit' pawn is playable but white can easily win back the pawn. (4.Qa4  or 4.e3 b5 5.a4 c6 6.axb cxb 7. b3!)",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 6,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',
        comment:
          'We have now reached the main line of the Queens gambit declined which is usually reached after the move order 1.d4 d5 2.c4 e6 3.Nc3 Nf6 4.Nf3 (Although 4.Bg5 is more common.) Now after 4...Be7 and 5.Bg5 play continues as normal but with blacks next move he introduces the Tarrasch Defence.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'c7',
        moveTo: 'c5',
        fen: 'rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',
        comment:
          'Here we are at the Tarrasch Defence.   Usually in the QGD blacks main goals are e5 or c5. Here with the Tarrasch Defence black achieves this goal early however, it can lead to a slight strategic advantage to white.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 8,
        moveFrom: 'c4',
        moveTo: 'd5',
        fen: 'rnbqkb1r/pp3ppp/4pn2/2pP4/3P4/2N2N2/PP2PPPP/R1BQKB1R',
        comment:
          "By far the best and most common move. If 5...exd then the Tarrasch Defence is introduced or if 5...Nxd5 then the Semi-Tarrasch is introduced.  With the Tarrasch Defence black accepts an isolated d pawn for smooth development and plenty of space. Many GM's have played the Tarrasch Defence now and again including former World Champion Garry Kasparov until Karpov with the white pieces outplayed him in the World Championship match. In this defence white plays against black's isolated pawn while black tries to use his piece mobility to lauch an attack.  Unlike it's cousin, the Semi-Tarrasch Defence does not give black an islolated d-pawn but instead allows white to build a strong center. (See game)",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'f6',
        moveTo: 'd5',
        fen: 'rnbqkb1r/pp3ppp/4p3/2pn4/3P4/2N2N2/PP2PPPP/R1BQKB1R',
        comment:
          'After a slightly uncommon move order we reach the Semi-Tarrasch Defence. As said before white obtains an advantage after the following moves.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 10,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkb1r/pp3ppp/4p3/2pn4/3PP3/2N2N2/PP3PPP/R1BQKB1R',
        comment:
          'Logical and in my opinion the best move. Black is voluntarily allowing his knight to be driven around the board there is no reason why white should not do just that.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'd5',
        moveTo: 'c3',
        fen: 'rnbqkb1r/pp3ppp/4p3/2p5/3PP3/2n2N2/PP3PPP/R1BQKB1R',
        comment:
          "The only correct move as it gains tempi and trades off pieces to lessen a future attack. However the disadvantages are obvious as white's b pawn has now been converted to a c pawn increasing white's centeral majority.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'b2',
        moveTo: 'c3',
        fen: 'rnbqkb1r/pp3ppp/4p3/2p5/3PP3/2P2N2/P4PPP/R1BQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 13,
        moveFrom: 'c5',
        moveTo: 'd4',
        fen: 'rnbqkb1r/pp3ppp/4p3/8/3pP3/2P2N2/P4PPP/R1BQKB1R',
        comment:
          "A critical point in the opening. Black has allowed white to obtain a large central space advantage and with 3 minor pieces on the board he should be looking to trade off pieces to lessen a future attack of white's. This is exactly what this move and Bb4  accomplish.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 14,
        moveFrom: 'c3',
        moveTo: 'd4',
        fen: 'rnbqkb1r/pp3ppp/4p3/8/3PP3/5N2/P4PPP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'f8',
        moveTo: 'b4',
        fen: 'rnbqk2r/pp3ppp/4p3/8/1b1PP3/5N2/P4PPP/R1BQKB1R',
        comment:
          "As mentioned this is played to trade off the minor pieces however after the trade black will be left with a very passive white bishop compared to white's active bishop. Therefore other ways of reaching equality have been tried such as Nc6 9. Bc4 b5! as played by Fischer against Spassky as Bxb5 loses to Qa5 .",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 16,
        moveFrom: 'c1',
        moveTo: 'd2',
        fen: 'rnbqk2r/pp3ppp/4p3/8/1b1PP3/5N2/P2B1PPP/R2QKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'b4',
        moveTo: 'd2',
        fen: 'rnbqk2r/pp3ppp/4p3/8/3PP3/5N2/P2b1PPP/R2QKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'd1',
        moveTo: 'd2',
        fen: 'rnbqk2r/pp3ppp/4p3/8/3PP3/5N2/P2Q1PPP/R3KB1R',
        comment:
          "Although black has suceeded in exchanging two sets of minor pieces white doesn't really mind as his two minor pieces are very well placed.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 19,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'rnbq1rk1/pp3ppp/4p3/8/3PP3/5N2/P2Q1PPP/R3KB1R',
        comment:
          "Now that the position has simplified we can analyse the position. There are only two sets of minor pieces on the board but white's bishop can come into play actively unlike black's white bishop while white's knight is also actively placed. White also has a large centeral majority and although the king looks awkward in the center its is perfectly safe.   Because of his small centeral majority, black's chances are on the queenside with his 2-1 pawn majority on the left wing. However, it will only be towards the endgame when black can exploit this and he must be content with developing and defending himself for now.   White on the other hand is looking for the d5 advance to create a passed pawn and even if it is not queened it will draw blacks forces away from his king where upon white will lauch an attack.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnbq1rk1/pp3ppp/4p3/8/2BPP3/5N2/P2Q1PPP/R3K2R',
        comment:
          'The best spot for the bishop as it helps the d5 advance. Furthermore, Bd3 and Be2 block the e and d files which white will want to place his rooks on.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'b8',
        moveTo: 'c6',
        fen: 'r1bq1rk1/pp3ppp/2n1p3/8/2BPP3/5N2/P2Q1PPP/R3K2R',
        comment:
          "At first sight this is a simply logical move as it develops the knight to the 'best' square. However, if white can get the d5 advance in black will be forced to lose time moving his knight a second time. Therefore there is alot to be said about Nd7. So, blacks move is completely in contrary with what is required and there is nothing wrong however it should be noted that Nd7 should also be considered as a possible move.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'r1bq1rk1/pp3ppp/2n1p3/8/2BPP3/5N2/P2Q1PPP/R4RK1',
        comment:
          "White needs his rooks on the open files to break through. Also after the coming d5 exd exd the e-file will be open and white's king could be vulnerable.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 23,
        moveFrom: 'b7',
        moveTo: 'b6',
        fen: 'r1bq1rk1/p4ppp/1pn1p3/8/2BPP3/5N2/P2Q1PPP/R4RK1',
        comment:
          'Blacks best move. He prepares the fianchetto which will activate his trapped bishop.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'f1',
        moveTo: 'e1',
        fen: 'r1bq1rk1/p4ppp/1pn1p3/8/2BPP3/5N2/P2Q1PPP/R3R1K1',
        comment:
          'Whites rooks mobolise as quickly as possible. Another possible move is Rfd1 when the a-rook goes to c1 however the prospects for the e-file opening are very good. Furthermore, white needs a protector of e4 as after Bb7 black might have nasty discoveries on the unprotected pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'c8',
        moveTo: 'b7',
        fen: 'r2q1rk1/pb3ppp/1pn1p3/8/2BPP3/5N2/P2Q1PPP/R3R1K1',
        comment: 'Logical follow up.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'a1',
        moveTo: 'd1',
        fen: 'r2q1rk1/pb3ppp/1pn1p3/8/2BPP3/5N2/P2Q1PPP/3RR1K1',
        comment:
          'White has now completed his objective and has mobilised his rooks and is ready to play d5.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'c6',
        moveTo: 'e7',
        fen: 'r2q1rk1/pb2nppp/1p2p3/8/2BPP3/5N2/P2Q1PPP/3RR1K1',
        comment:
          'With this move black anticipates the coming d5 advance and although it is too late to stop the pawn, after d5 exd exd black has Nf5 and Nd6 to blockade the pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'd4',
        moveTo: 'd5',
        fen: 'r2q1rk1/pb2nppp/1p2p3/3P4/2B1P3/5N2/P2Q1PPP/3RR1K1',
        comment:
          "! With all white's forces ready he breaks through. Now he must watch for the Nd6 blockading maneuvre as mentioned previously.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'e6',
        moveTo: 'd5',
        fen: 'r2q1rk1/pb2nppp/1p6/3p4/2B1P3/5N2/P2Q1PPP/3RR1K1',
        comment: 'It is necessary to exchange pawns to free the f5 square.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'e4',
        moveTo: 'd5',
        fen: 'r2q1rk1/pb2nppp/1p6/3P4/2B5/5N2/P2Q1PPP/3RR1K1',
        comment:
          'White has now obtained what he wants, a passed pawn but he must now work on trying to queen the pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'e7',
        moveTo: 'f5',
        fen: 'r2q1rk1/pb3ppp/1p6/3P1n2/2B5/5N2/P2Q1PPP/3RR1K1',
        comment: 'With the idea of Nd6 blockading the pawn but Petrosian has an excellent move.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'f3',
        moveTo: 'e5',
        fen: 'r2q1rk1/pb3ppp/1p6/3PNn2/2B5/8/P2Q1PPP/3RR1K1',
        comment:
          '! This is in my opinion an excellent move because it prepares to bring the knight to c6 where it will either cause much annoyance for black if he leaves it there or he will have to exchange it for his white bishop turning the passed d pawn into a passed c pawn meaning the blockading move Nd6 is useless.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'f5',
        moveTo: 'd6',
        fen: 'r2q1rk1/pb3ppp/1p1n4/3PN3/2B5/8/P2Q1PPP/3RR1K1',
        comment:
          'So black blocks the passed pawn but with the Nc6! move coming he brings a little trouble about himself.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'e5',
        moveTo: 'c6',
        fen: 'r2q1rk1/pb3ppp/1pNn4/3P4/2B5/8/P2Q1PPP/3RR1K1',
        comment:
          '! Now black has 3 choices 1. trade the bishop for the knight (See game) 2. Attempt to ignore the knight by Qf6 after which white will protect the bishop and black will have to endure a awful middle game due to the well placed knight. 3. An attempt to win a piece with 18...Nxc4 when after 19.Nxd8 Nxd2 20.Nxb7 Rab8 21.Na5!! bxa5 Rxd2 he is left with 2 doubled A pawns which have no chance of becoming passed while white still has the passed d pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'b7',
        moveTo: 'c6',
        fen: 'r2q1rk1/p4ppp/1pbn4/3P4/2B5/8/P2Q1PPP/3RR1K1',
        comment:
          "? From all the alternatives mentioned, this is the worst continuation although it temporarily wins a piece black has no way to block the future passed c pawn and with less pieces on the board white's passed pawn is increasing in power and this ultimately leads to blacks downfall.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 36,
        moveFrom: 'd5',
        moveTo: 'c6',
        fen: 'r2q1rk1/p4ppp/1pPn4/8/2B5/8/P2Q1PPP/3RR1K1',
        comment:
          "So now white's passed pawn has turned from d - c meaning the Nd6 is completely pointless therefore black exchanges it for white's bishop.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 37,
        moveFrom: 'd6',
        moveTo: 'c4',
        fen: 'r2q1rk1/p4ppp/1pP5/8/2n5/8/P2Q1PPP/3RR1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 38,
        moveFrom: 'd2',
        moveTo: 'f4',
        fen: 'r2q1rk1/p4ppp/1pP5/8/2n2Q2/8/P4PPP/3RR1K1',
        comment:
          '! Winning back the piece as there is a discovered attack on the queen. Wrong is Qxd8? when Raxd8 21. Rxd8 Rxd8 22.c7 loses to Rf8! (eg 23. Rd1 b5! 24.Rd8 Nb6!.) So black must now give back the piece.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'c4',
        moveTo: 'd6',
        fen: 'r2q1rk1/p4ppp/1pPn4/8/5Q2/8/P4PPP/3RR1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'd1',
        moveTo: 'd6',
        fen: 'r2q1rk1/p4ppp/1pPR4/8/5Q2/8/P4PPP/4R1K1',
        comment:
          '! White keeps the queens on the board (instead of Qxd6) which allows him to attack on the K-side while blacks pieces are tied down to defending the passed c-pawn. This move also gains a tempi which will help white.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'd8',
        moveTo: 'c7',
        fen: 'r4rk1/p1q2ppp/1pPR4/8/5Q2/8/P4PPP/4R1K1',
        comment: 'With the sensible and logical idea of blockading the pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'g2',
        moveTo: 'g3',
        fen: 'r4rk1/p1q2ppp/1pPR4/8/5Q2/6P1/P4P1P/4R1K1',
        comment:
          "Petrosian realises that black has no winning prospects and cannot do anything as his  pawn majority on the left wing is of no value in comparison to white's passed pawn. Therefore he takes his time, firstly by giving his king some 'luft' so that the Re1 is free to maneuvre if necessary.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 43,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'r4rk1/p1q2pp1/1pPR3p/8/5Q2/6P1/P4P1P/4R1K1',
        comment:
          'Black wants to give his king some luft to prevent back rank mates as there could be many threats to the back rank to come. However, perhaps such a weakening of the kings position mightnt be necessary at this point in time as white has no direct threats against the back rank.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'f4',
        moveTo: 'e5',
        fen: 'r4rk1/p1q2pp1/1pPR3p/4Q3/8/6P1/P4P1P/4R1K1',
        comment:
          '! With this move (and the next) White demonstrates his complete superiority over black as he can take his time to maneuvre since black cannot do anything productive. Rae8 loses to 24.Qxe8! Rxe8 25. Rxe8 Kh7 26.Red8 since the passed pawn is too strong.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'a8',
        moveTo: 'c8',
        fen: '2r2rk1/p1q2pp1/1pPR3p/4Q3/8/6P1/P4P1P/4R1K1',
        comment:
          'With nothing to do, black hopes to at least prevent white from queening the pawn with all his forces. However, this allows white to launch an attack.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 46,
        moveFrom: 'e5',
        moveTo: 'd5',
        fen: '2r2rk1/p1q2pp1/1pPR3p/3Q4/8/6P1/P4P1P/4R1K1',
        comment:
          '! Petrosian protects his pawn again while centeralising his queen to the best square possible. White is completely dominating and the only thing which remains to be given a useful job is the rook.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 47,
        moveFrom: 'g8',
        moveTo: 'h7',
        fen: '2r2r2/p1q2ppk/1pPR3p/3Q4/8/6P1/P4P1P/4R1K1',
        comment:
          "Black is simply bidding his time however I think this is a psycological surrender as Petrosian with his next move realises blacks 'surrender' and plans an attack.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 48,
        moveFrom: 'e1',
        moveTo: 'e4',
        fen: '2r2r2/p1q2ppk/1pPR3p/3Q4/4R3/6P1/P4P1P/6K1',
        comment:
          'Instead of the Rd7 which can be played anytime, Petrosian plans the attack. Now his rook can come to f4, g4, and h4.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 49,
        moveFrom: 'h7',
        moveTo: 'g8',
        fen: '2r2rk1/p1q2pp1/1pPR3p/3Q4/4R3/6P1/P4P1P/6K1',
        comment: 'Bidding time.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 50,
        moveFrom: 'g1',
        moveTo: 'g2',
        fen: '2r2rk1/p1q2pp1/1pPR3p/3Q4/4R3/6P1/P4PKP/8',
        comment:
          "! With black's forces distracted by the passed pawn white advances his king as well as the g pawn which will be used to break into black's king. This move becomes more apparent after black's 31st move as it also prevents any checks on the back rank.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 51,
        moveFrom: 'a7',
        moveTo: 'a6',
        fen: '2r2rk1/2q2pp1/ppPR3p/3Q4/4R3/6P1/P4PKP/8',
        comment: 'Preparing b5 to give some hopeful counterplay but right now black is quite lost.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 52,
        moveFrom: 'h2',
        moveTo: 'h4',
        fen: '2r2rk1/2q2pp1/ppPR3p/3Q4/4R2P/6P1/P4PK1/8',
        comment: 'Black can do nothing against this slow but steady advance of the pawns.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 53,
        moveFrom: 'b6',
        moveTo: 'b5',
        fen: '2r2rk1/2q2pp1/p1PR3p/1p1Q4/4R2P/6P1/P4PK1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 54,
        moveFrom: 'g3',
        moveTo: 'g4',
        fen: '2r2rk1/2q2pp1/p1PR3p/1p1Q4/4R1PP/8/P4PK1/8',
        comment:
          'White is now preparing the g5 break. Just watch how Petrosian calmly maneuvers his pieces.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 55,
        moveFrom: 'g8',
        moveTo: 'h7',
        fen: '2r2r2/2q2ppk/p1PR3p/1p1Q4/4R1PP/8/P4PK1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'e4',
        moveTo: 'e2',
        fen: '2r2r2/2q2ppk/p1PR3p/1p1Q4/6PP/8/P3RPK1/8',
        comment:
          '! A very flexible move. The reason behind this move is that when white plays g5 black might block the position with h5 and g6 when the hole on f6 will become a weakness. Re2 allows the queen to come to f3 so that if the h5 g6 maneuvre is played, the queen can exploit the hole on f6. Furthermore, the rook is better positioned here as it can come to the c-file or d-file if necessary where as on e4 it cannot come to c4. It sometimes seems unecessary to do this move and if black had certain threats/counterplay it probably would be a waste of a move. However black do anything productive so white can afford to take his time.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'h7',
        moveTo: 'h8',
        fen: '2r2r1k/2q2pp1/p1PR3p/1p1Q4/6PP/8/P3RPK1/8',
        comment: 'Black is still bidding his time...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 58,
        moveFrom: 'g4',
        moveTo: 'g5',
        fen: '2r2r1k/2q2pp1/p1PR3p/1p1Q2P1/7P/8/P3RPK1/8',
        comment:
          '!! Finally the g5 break. If hxg hxg black will lose quickly due to the open h-file.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'h6',
        moveTo: 'h5',
        fen: '2r2r1k/2q2pp1/p1PR4/1p1Q2Pp/7P/8/P3RPK1/8',
        comment:
          'Blacks best move. He blocks the position around the king but as mentioned, when the queen comes to f3 he will have a hole on f6.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 60,
        moveFrom: 'e2',
        moveTo: 'd2',
        fen: '2r2r1k/2q2pp1/p1PR4/1p1Q2Pp/7P/8/P2R1PK1/8',
        comment:
          "White protects the rook so enabling his queen to come to f3. He doesn't mind giving up the e-file as it is of no use to him.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'f8',
        moveTo: 'e8',
        fen: '2r1r2k/2q2pp1/p1PR4/1p1Q2Pp/7P/8/P2R1PK1/8',
        comment:
          'Black takes control of the e-file but this comes too late. Only now can one appreciate the importance of the 26.Kg2! move as if it were on g1 black would have drawing chances with Re1  and Rc1.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'd5',
        moveTo: 'f3',
        fen: '2r1r2k/2q2pp1/p1PR4/1p4Pp/7P/5Q2/P2R1PK1/8',
        comment:
          'White finally achieves his goal. Although there is no weakness on the f6 square yet, blacks next move is forced to protect the h pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'g7',
        moveTo: 'g6',
        fen: '2r1r2k/2q2p2/p1PR2p1/1p4Pp/7P/5Q2/P2R1PK1/8',
        comment:
          'The only move to protect the h-pawn but now the f6 square will be a permanant weakness.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 64,
        moveFrom: 'd2',
        moveTo: 'd5',
        fen: '2r1r2k/2q2p2/p1PR2p1/1p1R2Pp/7P/5Q2/P4PK1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 65,
        moveFrom: 'e8',
        moveTo: 'f8',
        fen: '2r2r1k/2q2p2/p1PR2p1/1p1R2Pp/7P/5Q2/P4PK1/8',
        comment:
          "Black's f pawn is also a weakness and since the rook is doing nothing useful on the e-file he bolsters the pawn.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 66,
        moveFrom: 'd6',
        moveTo: 'f6',
        fen: '2r2r1k/2q2p2/p1P2Rp1/1p1R2Pp/7P/5Q2/P4PK1/8',
        comment:
          '! Making full use of the weakness and applying more pressure to the f-pawn. Furthermore he threatens the decisive Rd7!',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'c7',
        moveTo: 'e7',
        fen: '2r2r1k/4qp2/p1P2Rp1/1p1R2Pp/7P/5Q2/P4PK1/8',
        comment:
          'A final mistake. The point of this move was so that after Rd7 Qe8 the queen protects the f-pawn however, Korchnoi under time pressure misses the following combination.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 68,
        moveFrom: 'd5',
        moveTo: 'd7',
        fen: '2r2r1k/3Rqp2/p1P2Rp1/1p4Pp/7P/5Q2/P4PK1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'e7',
        moveTo: 'e8',
        fen: '2r1qr1k/3R1p2/p1P2Rp1/1p4Pp/7P/5Q2/P4PK1/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'f6',
        moveTo: 'g6',
        fen: '2r1qr1k/3R1p2/p1P3R1/1p4Pp/7P/5Q2/P4PK1/8',
        comment: '!! A very pretty move as fxg allows Qc3  followed by mate.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 71,
        moveFrom: 'e8',
        moveTo: 'e5',
        fen: '2r2r1k/3R1p2/p1P3R1/1p2q1Pp/7P/5Q2/P4PK1/8',
        comment: '?? Blunder due to time pressure but black was lost anyways.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 72,
        moveFrom: 'f3',
        moveTo: 'h5',
        fen: '2r2r1k/3R1p2/p1P3R1/1p2q1PQ/7P/8/P4PK1/8',
        comment:
          'An extremely complex game showing some ideas in the Semi-Tarrasch Defence, the importance of recognising a completely dominating position and taking your time to unleash the killer blow as well as how to set goals (such as the penetration of the weak f6 square) and work towards them.',
        isBestMoment: true,
        isPredictionRight: false,
      },
    ],
  },
  {
    id: 3,
    name: 'The Boa Constrictor.',
    accuracyPercentage: 0.717948717948718,
    recallPercentage: 0.5,
    precisionPercentage: 0.18181818181818182,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: 'A team game annotated for instructional purposes and improvement.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'c7',
        moveTo: 'c6',
        fen: 'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 2,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR',
        comment: 'Caro-Kann Defense',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'd7',
        moveTo: 'd5',
        fen: 'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'd5',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'c3',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'c8',
        moveTo: 'f5',
        fen: 'rn1qkbnr/pp2pppp/2p5/5b2/3PN3/8/PPP2PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'e4',
        moveTo: 'g3',
        fen: 'rn1qkbnr/pp2pppp/2p5/5b2/3P4/6N1/PPP2PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'f5',
        moveTo: 'g6',
        fen: 'rn1qkbnr/pp2pppp/2p3b1/8/3P4/6N1/PPP2PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'h2',
        moveTo: 'h4',
        fen: 'rn1qkbnr/pp2pppp/2p3b1/8/3P3P/6N1/PPP2PP1/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'rn1qkbnr/pp2ppp1/2p3bp/8/3P3P/6N1/PPP2PP1/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rn1qkbnr/pp2ppp1/2p3bp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rn1qkb1r/pp2ppp1/2p2nbp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'f3',
        moveTo: 'e5',
        fen: 'rn1qkb1r/pp2ppp1/2p2nbp/4N3/3P3P/6N1/PPP2PP1/R1BQKB1R',
        comment: 'Up to this point the classical line found in most opening data banks.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'g6',
        moveTo: 'h7',
        fen: 'rn1qkb1r/pp2pppb/2p2n1p/4N3/3P3P/6N1/PPP2PP1/R1BQKB1R',
        comment: 'Not willing to give up the bishop and stack the pawns.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 16,
        moveFrom: 'f1',
        moveTo: 'd3',
        fen: 'rn1qkb1r/pp2pppb/2p2n1p/4N3/3P3P/3B2N1/PPP2PP1/R1BQK2R',
        comment: 'Confronting the Bishop.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'h7',
        moveTo: 'd3',
        fen: 'rn1qkb1r/pp2ppp1/2p2n1p/4N3/3P3P/3b2N1/PPP2PP1/R1BQK2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 18,
        moveFrom: 'd1',
        moveTo: 'd3',
        fen: 'rn1qkb1r/pp2ppp1/2p2n1p/4N3/3P3P/3Q2N1/PPP2PP1/R1B1K2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'e7',
        moveTo: 'e6',
        fen: 'rn1qkb1r/pp3pp1/2p1pn1p/4N3/3P3P/3Q2N1/PPP2PP1/R1B1K2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 20,
        moveFrom: 'c1',
        moveTo: 'f4',
        fen: 'rn1qkb1r/pp3pp1/2p1pn1p/4N3/3P1B1P/3Q2N1/PPP2PP1/R3K2R',
        comment: 'All perfectly fine moves by both so far.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 21,
        moveFrom: 'd8',
        moveTo: 'a5',
        fen: 'rn2kb1r/pp3pp1/2p1pn1p/q3N3/3P1B1P/3Q2N1/PPP2PP1/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'f4',
        moveTo: 'd2',
        fen: 'rn2kb1r/pp3pp1/2p1pn1p/q3N3/3P3P/3Q2N1/PPPB1PP1/R3K2R',
        comment: 'Also good was c3, leaving the bishop on a strong diagonal.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'a5',
        moveTo: 'd5',
        fen: 'rn2kb1r/pp3pp1/2p1pn1p/3qN3/3P3P/3Q2N1/PPPB1PP1/R3K2R',
        comment: 'Striking at the g pawn.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 24,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'rn2kb1r/pp3pp1/2p1pn1p/3qN3/3P3P/3Q2N1/PPPB1PP1/R4RK1',
        comment:
          'Defending the pawn. Other options were, Nf3, f3 and Qb3. The last offering to exchange pawns and not fearing QxQ due to axb3 next which opens the file for the rook.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 25,
        moveFrom: 'b8',
        moveTo: 'd7',
        fen: 'r3kb1r/pp1n1pp1/2p1pn1p/3qN3/3P3P/3Q2N1/PPPB1PP1/R4RK1',
        comment: 'Doubling on the knight at e5.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 26,
        moveFrom: 'f1',
        moveTo: 'e1',
        fen: 'r3kb1r/pp1n1pp1/2p1pn1p/3qN3/3P3P/3Q2N1/PPPB1PP1/R3R1K1',
        comment: 'Guarding the knight. Also available was Nf3,Bf4 or f4.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'f8',
        moveTo: 'e7',
        fen: 'r3k2r/pp1nbpp1/2p1pn1p/3qN3/3P3P/3Q2N1/PPPB1PP1/R3R1K1',
        comment: 'Developing the bishop to a better square and allowing short side castling.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'c2',
        moveTo: 'c4',
        fen: 'r3k2r/pp1nbpp1/2p1pn1p/3qN3/2PP3P/3Q2N1/PP1B1PP1/R3R1K1',
        comment: 'Trying to displace the queen.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'd7',
        moveTo: 'e5',
        fen: 'r3k2r/pp2bpp1/2p1pn1p/3qn3/2PP3P/3Q2N1/PP1B1PP1/R3R1K1',
        comment: '...but black can counter which opens up the file for the lady to back up.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'e1',
        moveTo: 'e5',
        fen: 'r3k2r/pp2bpp1/2p1pn1p/3qR3/2PP3P/3Q2N1/PP1B1PP1/R5K1',
        comment: 'Now making the queen move.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'd5',
        moveTo: 'd7',
        fen: 'r3k2r/pp1qbpp1/2p1pn1p/4R3/2PP3P/3Q2N1/PP1B1PP1/R5K1',
        comment: 'The best place for her.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'a1',
        moveTo: 'e1',
        fen: 'r3k2r/pp1qbpp1/2p1pn1p/4R3/2PP3P/3Q2N1/PP1B1PP1/4R1K1',
        comment: 'Creating a rook battery on the open e file.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'e8',
        moveTo: 'c8',
        fen: '2kr3r/pp1qbpp1/2p1pn1p/4R3/2PP3P/3Q2N1/PP1B1PP1/4R1K1',
        comment: 'Castling and double attacking the d pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'c4',
        moveTo: 'c5',
        fen: '2kr3r/pp1qbpp1/2p1pn1p/2P1R3/3P3P/3Q2N1/PP1B1PP1/4R1K1',
        comment:
          'Whites first mistake. He fails to defend from the threat and gives up a valuable center pawn, thus opening a file for black. Called for was Bc3.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'd7',
        moveTo: 'd4',
        fen: '2kr3r/pp2bpp1/2p1pn1p/2P1R3/3q3P/3Q2N1/PP1B1PP1/4R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 36,
        moveFrom: 'd3',
        moveTo: 'd4',
        fen: '2kr3r/pp2bpp1/2p1pn1p/2P1R3/3Q3P/6N1/PP1B1PP1/4R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 37,
        moveFrom: 'd8',
        moveTo: 'd4',
        fen: '2k4r/pp2bpp1/2p1pn1p/2P1R3/3r3P/6N1/PP1B1PP1/4R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 38,
        moveFrom: 'd2',
        moveTo: 'e3',
        fen: '2k4r/pp2bpp1/2p1pn1p/2P1R3/3r3P/4B1N1/PP3PP1/4R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'd4',
        moveTo: 'a4',
        fen: '2k4r/pp2bpp1/2p1pn1p/2P1R3/r6P/4B1N1/PP3PP1/4R1K1',
        comment: 'Only makes white play a3.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'a2',
        moveTo: 'a3',
        fen: '2k4r/pp2bpp1/2p1pn1p/2P1R3/r6P/P3B1N1/1P3PP1/4R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'h8',
        moveTo: 'd8',
        fen: '2kr4/pp2bpp1/2p1pn1p/2P1R3/r6P/P3B1N1/1P3PP1/4R1K1',
        comment: 'Seizing the file back before white takes  it.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'g3',
        moveTo: 'e2',
        fen: '2kr4/pp2bpp1/2p1pn1p/2P1R3/r6P/P3B3/1P2NPP1/4R1K1',
        comment: 'Leaving h4 hanging still.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 43,
        moveFrom: 'f6',
        moveTo: 'g4',
        fen: '2kr4/pp2bpp1/2p1p2p/2P1R3/r5nP/P3B3/1P2NPP1/4R1K1',
        comment:
          'Leaving the h pawn for now and attacking the advanced rook plus threatening NxB and making a isolated pawn for white if the rook moves off the file.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'e2',
        moveTo: 'c3',
        fen: '2kr4/pp2bpp1/2p1p2p/2P1R3/r5nP/P1N1B3/1P3PP1/4R1K1',
        comment:
          'Countering which is usually good especially if there is no proper place for the white e5 rook to go.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'g4',
        moveTo: 'e5',
        fen: '2kr4/pp2bpp1/2p1p2p/2P1n3/r6P/P1N1B3/1P3PP1/4R1K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 46,
        moveFrom: 'c3',
        moveTo: 'a4',
        fen: '2kr4/pp2bpp1/2p1p2p/2P1n3/N6P/P3B3/1P3PP1/4R1K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 47,
        moveFrom: 'e7',
        moveTo: 'h4',
        fen: '2kr4/pp3pp1/2p1p2p/2P1n3/N6b/P3B3/1P3PP1/4R1K1',
        comment: 'Now picking up the lonely pawn. This make black up by two pawns.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 48,
        moveFrom: 'a4',
        moveTo: 'c3',
        fen: '2kr4/pp3pp1/2p1p2p/2P1n3/7b/P1N1B3/1P3PP1/4R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 49,
        moveFrom: 'e5',
        moveTo: 'd3',
        fen: '2kr4/pp3pp1/2p1p2p/2P5/7b/P1NnB3/1P3PP1/4R1K1',
        comment: 'Attacking the rook and b2.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 50,
        moveFrom: 'e1',
        moveTo: 'e2',
        fen: '2kr4/pp3pp1/2p1p2p/2P5/7b/P1NnB3/1P2RPP1/6K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 51,
        moveFrom: 'f7',
        moveTo: 'f5',
        fen: '2kr4/pp4p1/2p1p2p/2P2p2/7b/P1NnB3/1P2RPP1/6K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'g2',
        moveTo: 'g3',
        fen: '2kr4/pp4p1/2p1p2p/2P2p2/7b/P1NnB1P1/1P2RP2/6K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 53,
        moveFrom: 'h4',
        moveTo: 'f6',
        fen: '2kr4/pp4p1/2p1pb1p/2P2p2/8/P1NnB1P1/1P2RP2/6K1',
        comment: 'The threat is BxN and bxc3 making double isolated pawns.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 54,
        moveFrom: 'c3',
        moveTo: 'a4',
        fen: '2kr4/pp4p1/2p1pb1p/2P2p2/N7/P2nB1P1/1P2RP2/6K1',
        comment: 'Stopping the exchange.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 55,
        moveFrom: 'e6',
        moveTo: 'e5',
        fen: '2kr4/pp4p1/2p2b1p/2P1pp2/N7/P2nB1P1/1P2RP2/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'a4',
        moveTo: 'c3',
        fen: '2kr4/pp4p1/2p2b1p/2P1pp2/8/P1NnB1P1/1P2RP2/6K1',
        comment:
          'Going back seeing that black blocked himself from the previous threat. However black can simply play e4 (which he does) and you have wasted valuable time shuffling the knight. What was called for was f3 to stop or contend with the e4 push.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'e5',
        moveTo: 'e4',
        fen: '2kr4/pp4p1/2p2b1p/2P2p2/4p3/P1NnB1P1/1P2RP2/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'e2',
        moveTo: 'd2',
        fen: '2kr4/pp4p1/2p2b1p/2P2p2/4p3/P1NnB1P1/1P1R1P2/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'g7',
        moveTo: 'g5',
        fen: '2kr4/pp6/2p2b1p/2P2pp1/4p3/P1NnB1P1/1P1R1P2/6K1',
        comment: 'Advancing to squeeze the kings position.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 60,
        moveFrom: 'f2',
        moveTo: 'f4',
        fen: '2kr4/pp6/2p2b1p/2P2pp1/4pP2/P1NnB1P1/1P1R4/6K1',
        comment:
          'Not too much else to do. But this gives up a pawn by en passant. Better to have not moved the pawn.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 61,
        moveFrom: 'e4',
        moveTo: 'f3',
        fen: '2kr4/pp6/2p2b1p/2P2pp1/8/P1NnBpP1/1P1R4/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'c3',
        moveTo: 'd1',
        fen: '2kr4/pp6/2p2b1p/2P2pp1/8/P2nBpP1/1P1R4/3N2K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'h6',
        moveTo: 'h5',
        fen: '2kr4/pp6/2p2b2/2P2ppp/8/P2nBpP1/1P1R4/3N2K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 64,
        moveFrom: 'b2',
        moveTo: 'b4',
        fen: '2kr4/pp6/2p2b2/2P2ppp/1P6/P2nBpP1/3R4/3N2K1',
        comment:
          'Nf2 brings a defender closer and blocks the f3 pawn. White saw Nxb2 and was trying to remove the pawn to safety. Nf2 does keep the pawn safe as there is no longer a RxN at d1 possibility after the exchange on b2.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 65,
        moveFrom: 'f5',
        moveTo: 'f4',
        fen: '2kr4/pp6/2p2b2/2P3pp/1P3p2/P2nBpP1/3R4/3N2K1',
        comment: 'Squeezing tighter.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 66,
        moveFrom: 'g3',
        moveTo: 'f4',
        fen: '2kr4/pp6/2p2b2/2P3pp/1P3P2/P2nBp2/3R4/3N2K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'g5',
        moveTo: 'g4',
        fen: '2kr4/pp6/2p2b2/2P4p/1P3Pp1/P2nBp2/3R4/3N2K1',
        comment: 'Keeping the pawns connected which is stronger than two isolated files of pawns.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 68,
        moveFrom: 'd1',
        moveTo: 'f2',
        fen: '2kr4/pp6/2p2b2/2P4p/1P3Pp1/P2nBp2/3R1N2/6K1',
        comment: 'Now he sees Nf2.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'd3',
        moveTo: 'f2',
        fen: '2kr4/pp6/2p2b2/2P4p/1P3Pp1/P3Bp2/3R1n2/6K1',
        comment: 'Exchanging down to a won endgame.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'd2',
        moveTo: 'd8',
        fen: '2kR4/pp6/2p2b2/2P4p/1P3Pp1/P3Bp2/5n2/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 71,
        moveFrom: 'c8',
        moveTo: 'd8',
        fen: '3k4/pp6/2p2b2/2P4p/1P3Pp1/P3Bp2/5n2/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 72,
        moveFrom: 'e3',
        moveTo: 'f2',
        fen: '3k4/pp6/2p2b2/2P4p/1P3Pp1/P4p2/5B2/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 73,
        moveFrom: 'h5',
        moveTo: 'h4',
        fen: '3k4/pp6/2p2b2/2P5/1P3Ppp/P4p2/5B2/6K1',
        comment: 'Squeezing again.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 74,
        moveFrom: 'f2',
        moveTo: 'e3',
        fen: '3k4/pp6/2p2b2/2P5/1P3Ppp/P3Bp2/8/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 75,
        moveFrom: 'g4',
        moveTo: 'g3',
        fen: '3k4/pp6/2p2b2/2P5/1P3P1p/P3Bpp1/8/6K1',
        comment: 'Tighter still!',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 76,
        moveFrom: 'f4',
        moveTo: 'f5',
        fen: '3k4/pp6/2p2b2/2P2P2/1P5p/P3Bpp1/8/6K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 77,
        moveFrom: 'h4',
        moveTo: 'h3',
        fen: '3k4/pp6/2p2b2/2P2P2/1P6/P3Bppp/8/6K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 78,
        moveFrom: 'e3',
        moveTo: 'f4',
        fen: '3k4/pp6/2p2b2/2P2P2/1P3B2/P4ppp/8/6K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 79,
        moveFrom: 'f6',
        moveTo: 'd4',
        fen: '3k4/pp6/2p5/2P2P2/1P1b1B2/P4ppp/8/6K1',
        comment:
          'White survived the late middle game only to loose due to the two pawns he gave up much earlier.',
        isBestMoment: true,
        isPredictionRight: false,
      },
    ],
  },
  {
    id: 4,
    name: 'Challenge from robin_jones1988',
    accuracyPercentage: 0.625,
    recallPercentage: 0.5882352941176471,
    precisionPercentage: 0.4166666666666667,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment:
          'A really good game between 2 equal players. Could have gone either way, and certainly I have learnt a lot from mistakes both of us made through the match. Comments welcome...',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e5',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
        comment:
          'Having experimented with the Sicilian defense a few months ago I have returns to my prefered opening ...e5. Despite contrary advice I consider the best opening to be one that suits your style of play, or simply one that you are familiar with.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 2,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR',
        comment:
          'As a rule I prefer this to a Ruy Lopez opening (from blacks perspective), but I have had a number of disasters against the Lopez, so am probably biased against it.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'f8',
        moveTo: 'c5',
        fen: 'rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR',
        comment: 'Other variations playable, but again I am most comfortable with this.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'd2',
        moveTo: 'd3',
        fen: 'rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'b8',
        moveTo: 'c6',
        fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'g1',
        moveTo: 'e2',
        fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP4/PPP1NPPP/R1BQK2R',
        comment:
          "Clearly a pre-prepared move, I hadn't faced this before. I would normally expect Nf3, or Bg5 but as the game develops it becomes clear why white chose this.  Looking through variations now, Ng4 looks interesting. If 1) 6. d4 exd4 7. Na4, with a small advantage to black 2) 6. 0-0 Qh4 (possible since knight isn't on f3) 7. h3 (avoiding # on h2) Nxf2 looks pretty good for black, since black is going to have to give up the exchange",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP4/PPP1NPPP/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP4/PPP1NPPP/R1BQ1RK1',
        comment:
          "Castle early, castle often. Famous advice and adhered to here, although my castle is more a natural development of my position, white's castling is part of a greater scheme..",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'd7',
        moveTo: 'd6',
        fen: 'r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2NP4/PPP1NPPP/R1BQ1RK1',
        comment: 'Still developing, freeing the bishop',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'h2',
        moveTo: 'h3',
        fen: 'r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2NP3P/PPP1NPP1/R1BQ1RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 13,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'r1bq1rk1/ppp2pp1/2np1n1p/2b1p3/2B1P3/2NP3P/PPP1NPP1/R1BQ1RK1',
        comment:
          "In Irving Chernev's famous book, Logical Chess, he greatly criticizes weakening the structure in front of the king. I don't normally find any problems, at least against players my standard, so have continued to play h6.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 14,
        moveFrom: 'g1',
        moveTo: 'h1',
        fen: 'r1bq1rk1/ppp2pp1/2np1n1p/2b1p3/2B1P3/2NP3P/PPP1NPP1/R1BQ1R1K',
        comment:
          'The final stages of whites development are in action, and the reason for putting the knight on e2 clear. Kh1 unpins the f-pawn allowing him to make the push f4 undermining my center.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'c8',
        moveTo: 'd7',
        fen: 'r2q1rk1/pppb1pp1/2np1n1p/2b1p3/2B1P3/2NP3P/PPP1NPP1/R1BQ1R1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 16,
        moveFrom: 'f2',
        moveTo: 'f4',
        fen: 'r2q1rk1/pppb1pp1/2np1n1p/2b1p3/2B1PP2/2NP3P/PPP1N1P1/R1BQ1R1K',
        comment:
          'As predicted, I am unwise to take the pawn, as the variation 9...exf4 10. d4 Bb6 11. Bxf4 leaves white in a very strong position covering 5 ranks against my 3.  If any of my former students are reading this, they should note that in under 10 moves we have both completed development and are ready to start the middlegame, it is essential to prepare your forces in the beginning as rushing into attack early almost never pays off',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'c6',
        moveTo: 'a5',
        fen: 'r2q1rk1/pppb1pp1/3p1n1p/n1b1p3/2B1PP2/2NP3P/PPP1N1P1/R1BQ1R1K',
        comment:
          'Feeling concerned about the potencial problems on the kingside, I move to free up my queenside. This move will remove the powerfully placed bishop, allowing me to gain some control in the centre, and frees my c-pawn to help advances in the centre and queenside',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'c4',
        moveTo: 'b3',
        fen: 'r2q1rk1/pppb1pp1/3p1n1p/n1b1p3/4PP2/1BNP3P/PPP1N1P1/R1BQ1R1K',
        comment:
          'White knows he will be doubling pawns, and chooses to do so on the b-file rather than the c-file. Clearly allowing me to capture on the c4 square leaves his center very weak',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'a5',
        moveTo: 'b3',
        fen: 'r2q1rk1/pppb1pp1/3p1n1p/2b1p3/4PP2/1nNP3P/PPP1N1P1/R1BQ1R1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'a2',
        moveTo: 'b3',
        fen: 'r2q1rk1/pppb1pp1/3p1n1p/2b1p3/4PP2/1PNP3P/1PP1N1P1/R1BQ1R1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'f8',
        moveTo: 'e8',
        fen: 'r2qr1k1/pppb1pp1/3p1n1p/2b1p3/4PP2/1PNP3P/1PP1N1P1/R1BQ1R1K',
        comment: 'Supports the e-pawn if I manufacture a chance to push the d-pawn forward',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'f4',
        moveTo: 'f5',
        fen: 'r2qr1k1/pppb1pp1/3p1n1p/2b1pP2/4P3/1PNP3P/1PP1N1P1/R1BQ1R1K',
        comment:
          'Chooses to lock up the center. This move leaves me in a tricky position, I know he will attack down the g/h files, as indicated by his choice of opening, but both of my bishops are now blocked from helping to defend. My personal experience has shown that under an attack like this the best way to defend is attack',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 23,
        moveFrom: 'c7',
        moveTo: 'c6',
        fen: 'r2qr1k1/pp1b1pp1/2pp1n1p/2b1pP2/4P3/1PNP3P/1PP1N1P1/R1BQ1R1K',
        comment: 'Planning to push the d-pawn and hopefully break his chain of pawns',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'g2',
        moveTo: 'g4',
        fen: 'r2qr1k1/pp1b1pp1/2pp1n1p/2b1pP2/4P1P1/1PNP3P/1PP1N3/R1BQ1R1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'd6',
        moveTo: 'd5',
        fen: 'r2qr1k1/pp1b1pp1/2p2n1p/2bppP2/4P1P1/1PNP3P/1PP1N3/R1BQ1R1K',
        comment:
          'Unable to prevent anything happening kingside, I drive forward through the middle hoping to gain counterplay against the attack.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'g4',
        moveTo: 'g5',
        fen: 'r2qr1k1/pp1b1pp1/2p2n1p/2bppPP1/4P3/1PNP3P/1PP1N3/R1BQ1R1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 27,
        moveFrom: 'h6',
        moveTo: 'g5',
        fen: 'r2qr1k1/pp1b1pp1/2p2n2/2bppPp1/4P3/1PNP3P/1PP1N3/R1BQ1R1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 28,
        moveFrom: 'c1',
        moveTo: 'g5',
        fen: 'r2qr1k1/pp1b1pp1/2p2n2/2bppPB1/4P3/1PNP3P/1PP1N3/R2Q1R1K',
        comment:
          "White now has a very dangerous open g-file pointing straight at my king. From my point of view many things can go wrong, and white has a clear attack, bringing the h-pawn forwards with the help of his well placed f4 pawn. From black's side the plan is to open the center as whites king is very exposed.",
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 29,
        moveFrom: 'd5',
        moveTo: 'd4',
        fen: 'r2qr1k1/pp1b1pp1/2p2n2/2b1pPB1/3pP3/1PNP3P/1PP1N3/R2Q1R1K',
        comment:
          "This seems counterproductive as I want to open the center, but I can't force the position open at the minute, taking the e-pawn only results in strengthening the line as I won't be able to challenge it with pawns. I also thought the pin on the knight prevented me from protecting the d-pawn sufficiently.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'c3',
        moveTo: 'b1',
        fen: 'r2qr1k1/pp1b1pp1/2p2n2/2b1pPB1/3pP3/1P1P3P/1PP1N3/RN1Q1R1K',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'c5',
        moveTo: 'e7',
        fen: 'r2qr1k1/pp1bbpp1/2p2n2/4pPB1/3pP3/1P1P3P/1PP1N3/RN1Q1R1K',
        comment:
          'Repositioning the bishop, at the time this was played as a defensive move, and just waiting for white to commit to an attack.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'e2',
        moveTo: 'g3',
        fen: 'r2qr1k1/pp1bbpp1/2p2n2/4pPB1/3pP3/1P1P2NP/1PP5/RN1Q1R1K',
        comment:
          "Looking at this position it's understandable for white to make the move, but it turns out to be completely wrong...",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'f6',
        moveTo: 'e4',
        fen: 'r2qr1k1/pp1bbpp1/2p5/4pPB1/3pn3/1P1P2NP/1PP5/RN1Q1R1K',
        comment:
          'If now Bxe7 then Nxg3  loses the bishop at least after Kg1 (Kg2 sets up fork after Nxf1, and Kh2 leaves check after Nxf1 so loses the exchange)',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'g3',
        moveTo: 'e4',
        fen: 'r2qr1k1/pp1bbpp1/2p5/4pPB1/3pN3/1P1P3P/1PP5/RN1Q1R1K',
        comment:
          'The only move in the position. This puts whites knight on a very powerful outpost close to my king',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 35,
        moveFrom: 'e7',
        moveTo: 'g5',
        fen: 'r2qr1k1/pp1b1pp1/2p5/4pPb1/3pN3/1P1P3P/1PP5/RN1Q1R1K',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 36,
        moveFrom: 'd1',
        moveTo: 'g4',
        fen: 'r2qr1k1/pp1b1pp1/2p5/4pPb1/3pN1Q1/1P1P3P/1PP5/RN3R1K',
        comment:
          'Interestingly after such an aggressive start from white I had feared a continuation such as f6. However this slightly quieter move leads to a forceful attack supporting the h6 pawn forwards.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 37,
        moveFrom: 'g5',
        moveTo: 'h6',
        fen: 'r2qr1k1/pp1b1pp1/2p4b/4pP2/3pN1Q1/1P1P3P/1PP5/RN3R1K',
        comment:
          "Better than f6, as after 20. Nxg5 fxg5 21. Rg1 the pawn will fall, and white's attack is difficult to defend.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 38,
        moveFrom: 'b1',
        moveTo: 'd2',
        fen: 'r2qr1k1/pp1b1pp1/2p4b/4pP2/3pN1Q1/1P1P3P/1PPN4/R4R1K',
        comment:
          "Looking from white's point of view I realise I had missed the threat Nd6, winning back the pawn. It's possible white saw this but chose to continue the attack, which ended up more valuable than reclaiming the pawn he had lost.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 39,
        moveFrom: 'h6',
        moveTo: 'd2',
        fen: 'r2qr1k1/pp1b1pp1/2p5/4pP2/3pN1Q1/1P1P3P/1PPb4/R4R1K',
        comment:
          'Unwilling to let the knight join the attack I chose to remove it. It also gives me a tempo to try and set up some sort of counterattack down the center.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 40,
        moveFrom: 'e4',
        moveTo: 'd2',
        fen: 'r2qr1k1/pp1b1pp1/2p5/4pP2/3p2Q1/1P1P3P/1PPN4/R4R1K',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'c6',
        moveTo: 'c5',
        fen: 'r2qr1k1/pp1b1pp1/8/2p1pP2/3p2Q1/1P1P3P/1PPN4/R4R1K',
        comment:
          'About the best I could come up with, I now have lines open and aiming at the exposed white king. Despite this I do feel that my pawn advantage is a very slim one, if at all.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'd2',
        moveTo: 'e4',
        fen: 'r2qr1k1/pp1b1pp1/8/2p1pP2/3pN1Q1/1P1P3P/1PP5/R4R1K',
        comment:
          'Bringing the knight back to support the attack, and with a threat to capture the c5 pawn. This is easily blocked though.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 43,
        moveFrom: 'd7',
        moveTo: 'c6',
        fen: 'r2qr1k1/pp3pp1/2b5/2p1pP2/3pN1Q1/1P1P3P/1PP5/R4R1K',
        comment:
          'Pins the knight to the king, and will remove it next move. At this point I reasoned that fewer pieces on the board will mean a reduced attack.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'h1',
        moveTo: 'h2',
        fen: 'r2qr1k1/pp3pp1/2b5/2p1pP2/3pN1Q1/1P1P3P/1PP4K/R4R2',
        comment:
          'In my view a slow move, but then again I knew I would take the knight regardless of the move played (within reason)',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'c6',
        moveTo: 'e4',
        fen: 'r2qr1k1/pp3pp1/8/2p1pP2/3pb1Q1/1P1P3P/1PP4K/R4R2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 46,
        moveFrom: 'd3',
        moveTo: 'e4',
        fen: 'r2qr1k1/pp3pp1/8/2p1pP2/3pP1Q1/1P5P/1PP4K/R4R2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 47,
        moveFrom: 'f7',
        moveTo: 'f6',
        fen: 'r2qr1k1/pp4p1/5p2/2p1pP2/3pP1Q1/1P5P/1PP4K/R4R2',
        comment:
          "Played to allow my major pieces to defend the vulnerable g7 square against the threat of Rg1. However this wasn't the only threat white has in the position",
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 48,
        moveFrom: 'h3',
        moveTo: 'h4',
        fen: 'r2qr1k1/pp4p1/5p2/2p1pP2/3pP1QP/1P6/1PP4K/R4R2',
        comment:
          'Finally white proceeds as I had predicted back all those moves ago. The pawn on f6 now hinders my queen from moving in front of the king, so I have no real defense to this.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 49,
        moveFrom: 'e8',
        moveTo: 'e7',
        fen: 'r2q2k1/pp2r1p1/5p2/2p1pP2/3pP1QP/1P6/1PP4K/R4R2',
        comment:
          'This move would have to be played at some point, so might as well do it now. However the inevitable h5 comes next and a slow but unstopable threat is on the horizon. My only choice, as said many times before, is to attack',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 50,
        moveFrom: 'h4',
        moveTo: 'h5',
        fen: 'r2q2k1/pp2r1p1/5p2/2p1pP1P/3pP1Q1/1P6/1PP4K/R4R2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 51,
        moveFrom: 'd4',
        moveTo: 'd3',
        fen: 'r2q2k1/pp2r1p1/5p2/2p1pP1P/4P1Q1/1P1p4/1PP4K/R4R2',
        comment:
          'Penetrating into whites terratory, this also aims to clear the way for the manouever Q-d2-h6 if I have enough time. Though time is something that is decidedly against me',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'a1',
        moveTo: 'd1',
        fen: 'r2q2k1/pp2r1p1/5p2/2p1pP1P/4P1Q1/1P1p4/1PP4K/3R1R2',
        comment:
          'Naturally white has no incentive to play risky chess. His attack is well poised and I am rather floundering despite my material advantage',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 53,
        moveFrom: 'd8',
        moveTo: 'd4',
        fen: 'r5k1/pp2r1p1/5p2/2p1pP1P/3qP1Q1/1P1p4/1PP4K/3R1R2',
        comment:
          'Again penetrating into whites territory, praying that I can continue to distract him long enough to muster defense around the king',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 54,
        moveFrom: 'd1',
        moveTo: 'd3',
        fen: 'r5k1/pp2r1p1/5p2/2p1pP1P/3qP1Q1/1P1R4/1PP4K/5R2',
        comment:
          'A obvious but good move. Rooks are very strong when lined up on the same file. White now has the option to do this either on the g-file, building pressure on the g7 pawn, or he can move to control the open d-file',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 55,
        moveFrom: 'd4',
        moveTo: 'b2',
        fen: 'r5k1/pp2r1p1/5p2/2p1pP1P/4P1Q1/1P1R4/1qP4K/5R2',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 56,
        moveFrom: 'f1',
        moveTo: 'd1',
        fen: 'r5k1/pp2r1p1/5p2/2p1pP1P/4P1Q1/1P1R4/1qP4K/3R4',
        comment:
          'White creates a direct mating threat, after Rd8 and Qg6. This is pretty unstopable, aside from sacrificing the queen on d2. All white needs to do is set up a second threat with the h-pawn and I will be overrun.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 57,
        moveFrom: 'a8',
        moveTo: 'e8',
        fen: '4r1k1/pp2r1p1/5p2/2p1pP1P/4P1Q1/1P1R4/1qP4K/3R4',
        comment:
          'Last gasp defence. An immediate 30. Rd8 will likely fizzle out into a draw after 30...Qxc2  31. R1d2 Qxb3 32. Rxe8 Rxe8 33. Rd7 Qc2 , ending in repetition or perhaps a queen / rook endgame.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'h5',
        moveTo: 'h6',
        fen: '4r1k1/pp2r1p1/5p1P/2p1pP2/4P1Q1/1P1R4/1qP4K/3R4',
        comment:
          'This should be the final nail in the coffin, the threat of Rd8 is now very effective as my e7 rook is pinned to the g7 pawn to protect against checkmate in 1.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'g8',
        moveTo: 'h8',
        fen: '4r2k/pp2r1p1/5p1P/2p1pP2/4P1Q1/1P1R4/1qP4K/3R4',
        comment:
          "With the impending Rd8 I really want to move to f8, so the king can protect the e8 rook (since the e7 rook can't). But the threat of h7! makes that impossible. No other feasible move to make, so just sit back and decide when to hit resign",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 60,
        moveFrom: 'd3',
        moveTo: 'd7',
        fen: '4r2k/pp1Rr1p1/5p1P/2p1pP2/4P1Q1/1P6/1qP4K/3R4',
        comment:
          'Having played a near flawless attack, white finally slips up just when he had me where he wanted me. Rd8 is crushing, leading to a queen sacrifice as the only way to prevent checkmate.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'e7',
        moveTo: 'd7',
        fen: '4r2k/pp1r2p1/5p1P/2p1pP2/4P1Q1/1P6/1qP4K/3R4',
        comment: 'Forced',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'd1',
        moveTo: 'd7',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P6/1qP4K/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'b2',
        moveTo: 'c2',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P6/2q4K/8',
        comment:
          "The only move, I can now push whites king around waiting for him to block with his queen forcing a drawn endgame, or force a draw through repetition. Really a lifeline I didn't deserve having been outplayed all match, but chances like this don't come every day and I had to stay alert to make sure I don't slip up and gift my opponent a win in a drawn position",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 64,
        moveFrom: 'h2',
        moveTo: 'h3',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P5K/2q5/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 65,
        moveFrom: 'c2',
        moveTo: 'c3',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1Pq4K/8/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 66,
        moveFrom: 'h3',
        moveTo: 'g2',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1Pq5/6K1/8',
        comment:
          'Note that 34. Kh4 leads to 34...Qe1 and 35...Qh1 forcing a queen exchange in 1-3 moves (depending on the variation). After which I can take the h6 pawn giving me a pawn advantage 5-3 in the endgame (after Rxb7), and thus potencial winning chances.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'c3',
        moveTo: 'c2',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P6/2q3K1/8',
        comment:
          'Plan seems to be working, I felt sure this match is heading for a draw by repetition. This is the best result for white, despite having been in charge for most of the match.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 68,
        moveFrom: 'g2',
        moveTo: 'f1',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P6/2q5/5K2',
        comment: 'Another critical blunder...',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'c2',
        moveTo: 'c1',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P6/8/2q2K2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'f1',
        moveTo: 'e2',
        fen: '4r2k/pp1R2p1/5p1P/2p1pP2/4P1Q1/1P6/4K3/2q5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 71,
        moveFrom: 'c1',
        moveTo: 'h6',
        fen: '4r2k/pp1R2p1/5p1q/2p1pP2/4P1Q1/1P6/4K3/8',
        comment:
          'Winning the h6 pawn and defends against Qxg7#. The middlegame is now over, and a queen   rook endgame is in progress. As in any major piece endgame piece activity is far more important than material advantage. A well placed rook vs Inactive rook can be an advantage of up to 2 pawns, so this finale should be anything but easy to convert',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 72,
        moveFrom: 'd7',
        moveTo: 'b7',
        fen: '4r2k/pR4p1/5p1q/2p1pP2/4P1Q1/1P6/4K3/8',
        comment:
          'Grabbing the free pawn quite correctly, but even a quick glance at the position shows that for the first time in the match black has gained a winning position. An advantage of 5 pawns to 3. Here it is tempting to move Ra8 defending the a-pawn, but this takes my rook right out of the game...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 73,
        moveFrom: 'e8',
        moveTo: 'd8',
        fen: '3r3k/pR4p1/5p1q/2p1pP2/4P1Q1/1P6/4K3/8',
        comment:
          "Rd8 however gives me a well placed rook in a dangerous position holding the open file, worth more to me than the isolated pawn on a7. Also since the pawn is not a passed pawn, (the b3 pawn can take it) my plan can't be to just push the pawns to the end of the board, supported by rook and queen",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 74,
        moveFrom: 'b7',
        moveTo: 'a7',
        fen: '3r3k/R5p1/5p1q/2p1pP2/4P1Q1/1P6/4K3/8',
        comment:
          'Continuing to grab pawns, but still with a material deficit. His rook is miles away from the action, while I now have a great opportunity to close a box around the white king using my well placed rook and queen.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 75,
        moveFrom: 'd8',
        moveTo: 'd2',
        fen: '7k/R5p1/5p1q/2p1pP2/4P1Q1/1P6/3rK3/8',
        comment:
          'The rook check is preferable to a queen check, as my rook is brought up the board to smother the king. A queen check would lead to the same result, but I would still need to bring the rook to this quarter of the board to seal checkmate, so further queen checks would be needed to allow the rook to arrive on the scene',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 76,
        moveFrom: 'e2',
        moveTo: 'f3',
        fen: '7k/R5p1/5p1q/2p1pP2/4P1Q1/1P3K2/3r4/8',
        comment:
          '1 of 3 moves available 1) Kf3, the game line 2) Kf1, leading to Qh1 and Qf3 and checkmate to follow 3) Ke2, leading to Qe3 and checkmate to follow So in all probably the best move, but failing an awful blunder, white is lost',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 77,
        moveFrom: 'h6',
        moveTo: 'h1',
        fen: '7k/R5p1/5p2/2p1pP2/4P1Q1/1P3K2/3r4/7q',
        comment:
          'Closing the box, Only 2 options 1) Kg3, the gameline 2) Ke3 leading to Qe1 and Qf2#',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 78,
        moveFrom: 'f3',
        moveTo: 'g3',
        fen: '7k/R5p1/5p2/2p1pP2/4P1Q1/1P4K1/3r4/7q',
        comment: 'Only way to avoid checkmate, but...',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 79,
        moveFrom: 'd2',
        moveTo: 'g2',
        fen: '7k/R5p1/5p2/2p1pP2/4P1Q1/1P4K1/6r1/7q',
        comment:
          "! secures my opponents resignation, my queen and rook will either force checkmate in a few, or I can take his queen and ease to victory Q vs R. Either way white saves himself some time and resigns. In all a good match, both players showed some really good positional play, in the face of losing material we kept to our guns and showed material isn't everything. Any comments on the game are welcomed, and I understand Robin is doing his own annotation of the game, so look out for that.",
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 5,
    name: 'The Open File vs. The Open King',
    accuracyPercentage: 0.45,
    recallPercentage: 0.6666666666666666,
    precisionPercentage: 0.16666666666666666,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: 'I started the game into a King pawn oppenig..',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e5',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: 'Black answers directly in the opening..',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'd7',
        moveTo: 'd6',
        fen: 'rnbqkbnr/ppp2ppp/3p4/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
        comment: 'A bad defense.. It will block the movement of opponent black bishop...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 4,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqkbnr/ppp2ppp/3p4/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R',
        comment: 'I am starting to development my pieces..',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'c7',
        moveTo: 'c6',
        fen: 'rnbqkbnr/pp3ppp/2pp4/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R',
        comment: 'Black move c6 to support the advancement of d6 to d5..',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnbqkbnr/pp3ppp/2pp4/4p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R',
        comment:
          "The white bishop block the pawn threat at d5.... If I didn't do that, my opponent will have advantage in the center..",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 7,
        moveFrom: 'c8',
        moveTo: 'e6',
        fen: 'rn1qkbnr/pp3ppp/2ppb3/4p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R',
        comment:
          'I accept the trade of bishop because It can weaken the defense in the king side..',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 8,
        moveFrom: 'c4',
        moveTo: 'e6',
        fen: 'rn1qkbnr/pp3ppp/2ppB3/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'f7',
        moveTo: 'e6',
        fen: 'rn1qkbnr/pp4pp/2ppp3/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rn1qkbnr/pp4pp/2ppp3/4p3/3PP3/2N2N2/PPP2PPP/R1BQK2R',
        comment: 'This move gives lot of movement to knight, bishop and queen..',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'rn1qkbnr/pp4p1/2ppp2p/4p3/3PP3/2N2N2/PPP2PPP/R1BQK2R',
        comment: 'that is a mistake.. bcoz of 7. d4xe5...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 12,
        moveFrom: 'd4',
        moveTo: 'e5',
        fen: 'rn1qkbnr/pp4p1/2ppp2p/4P3/4P3/2N2N2/PPP2PPP/R1BQK2R',
        comment: 'so the best move for black is to move the pawn..',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'd6',
        moveTo: 'e5',
        fen: 'rn1qkbnr/pp4p1/2p1p2p/4p3/4P3/2N2N2/PPP2PPP/R1BQK2R',
        comment: 'another mistake for black..',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 14,
        moveFrom: 'd1',
        moveTo: 'd8',
        fen: 'rn1Qkbnr/pp4p1/2p1p2p/4p3/4P3/2N2N2/PPP2PPP/R1B1K2R',
        comment: 'The trade of queen lost black chance of castling..',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 15,
        moveFrom: 'e8',
        moveTo: 'd8',
        fen: 'rn1k1bnr/pp4p1/2p1p2p/4p3/4P3/2N2N2/PPP2PPP/R1B1K2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 16,
        moveFrom: 'f3',
        moveTo: 'e5',
        fen: 'rn1k1bnr/pp4p1/2p1p2p/4N3/4P3/2N5/PPP2PPP/R1B1K2R',
        comment: 'I am planning to fork the king and the rook..',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 17,
        moveFrom: 'd8',
        moveTo: 'c7',
        fen: 'rn3bnr/ppk3p1/2p1p2p/4N3/4P3/2N5/PPP2PPP/R1B1K2R',
        comment: 'Another mistake.. The best move is Ke8',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 18,
        moveFrom: 'c1',
        moveTo: 'f4',
        fen: 'rn3bnr/ppk3p1/2p1p2p/4N3/4PB2/2N5/PPP2PPP/R3K2R',
        comment:
          'the bishop will provide a check when I move the knight in f7... If the opponent make a mistake, then black will lost rook..',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'c7',
        moveTo: 'c8',
        fen: 'rnk2bnr/pp4p1/2p1p2p/4N3/4PB2/2N5/PPP2PPP/R3K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'e1',
        moveTo: 'c1',
        fen: 'rnk2bnr/pp4p1/2p1p2p/4N3/4PB2/2N5/PPP2PPP/2KR3R',
        comment:
          'I decided to castling the rook and the king on the queen side bcoz of the rook power in d file..',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'g7',
        moveTo: 'g5',
        fen: 'rnk2bnr/pp6/2p1p2p/4N1p1/4PB2/2N5/PPP2PPP/2KR3R',
        comment: 'watch for the checkmate',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'e5',
        moveTo: 'f7',
        fen: 'rnk2bnr/pp3N2/2p1p2p/6p1/4PB2/2N5/PPP2PPP/2KR3R',
        comment:
          'white near to victory.. bcoz of the move, rook to d8.. the only hope for black is to take the bishop... then I will eat the take rook...',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'h8',
        moveTo: 'h7',
        fen: 'rnk2bn1/pp3N1r/2p1p2p/6p1/4PB2/2N5/PPP2PPP/2KR3R',
        comment: 'Black lost bcoz of this blunder...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 24,
        moveFrom: 'd1',
        moveTo: 'd8',
        fen: 'rnkR1bn1/pp3N1r/2p1p2p/6p1/4PB2/2N5/PPP2PPP/2K4R',
        comment:
          'victory...  If you observe the game carefully, the reason why I win against black are the open d file that occupy by the rook, the weak defense, the open king, no development of black pieces, the lost of castling to black and enemy blunder..',
        isBestMoment: true,
        isPredictionRight: false,
      },
    ],
  },
  {
    id: 6,
    name: 'Benoni',
    accuracyPercentage: 0.631578947368421,
    recallPercentage: 0.4,
    precisionPercentage: 0.15384615384615385,
    plays: [
      {
        id: 0,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment:
          "This game is is titled 'The last march of the Pawns.' The cool thing about this game is that at one point goes up a rook in material. However yet it is he who ends up in the mating net.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e6',
        fen: 'rnbqkbnr/pppp1ppp/4p3/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 3,
        moveFrom: 'c7',
        moveTo: 'c5',
        fen: 'rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/8/PPP2PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'c2',
        moveTo: 'c4',
        fen: 'rnbqkbnr/pp1p1ppp/4p3/2p5/2PPP3/8/PP3PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'c5',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pp1p1ppp/4p3/8/2PpP3/8/PP3PPP/RNBQKBNR',
        comment:
          'With this move black eliminates one of white center pawns and gains a small initiative against the white queen',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'd1',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pp1p1ppp/4p3/8/2PQP3/8/PP3PPP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'b8',
        moveTo: 'c6',
        fen: 'r1bqkbnr/pp1p1ppp/2n1p3/8/2PQP3/8/PP3PPP/RNB1KBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'd4',
        moveTo: 'd1',
        fen: 'r1bqkbnr/pp1p1ppp/2n1p3/8/2P1P3/8/PP3PPP/RNBQKBNR',
        comment:
          'I played the queen back to her orginal square because at this point I was not sure which diagonal she would be best on. Also I wanted to keep my bishop lines clear and free. AT this point my goal is to setup a typical mazanony bind in the centre.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'r1bqkb1r/pp1p1ppp/2n1pn2/8/2P1P3/8/PP3PPP/RNBQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 10,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'r1bqkb1r/pp1p1ppp/2n1pn2/8/2P1P3/2N5/PP3PPP/R1BQKBNR',
        comment: 'defending the e4 pawn and developing my knight to a central square.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 11,
        moveFrom: 'f8',
        moveTo: 'b4',
        fen: 'r1bqk2r/pp1p1ppp/2n1pn2/8/1bP1P3/2N5/PP3PPP/R1BQKBNR',
        comment:
          'a pin in the spirit of the mizo-Indian defense. Black is trying to create pressure on e4.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'g1',
        moveTo: 'e2',
        fen: 'r1bqk2r/pp1p1ppp/2n1pn2/8/1bP1P3/2N5/PP2NPPP/R1BQKB1R',
        comment:
          'This is weaker than Qc2 because it lets black take e4 with very little consequence.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'f6',
        moveTo: 'e4',
        fen: 'r1bqk2r/pp1p1ppp/2n1p3/8/1bP1n3/2N5/PP2NPPP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'd1',
        moveTo: 'c2',
        fen: 'r1bqk2r/pp1p1ppp/2n1p3/8/1bP1n3/2N5/PPQ1NPPP/R1B1KB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'd8',
        moveTo: 'h4',
        fen: 'r1b1k2r/pp1p1ppp/2n1p3/8/1bP1n2q/2N5/PPQ1NPPP/R1B1KB1R',
        comment: 'Defending e4 and threatening mate on f2.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 16,
        moveFrom: 'c1',
        moveTo: 'e3',
        fen: 'r1b1k2r/pp1p1ppp/2n1p3/8/1bP1n2q/2N1B3/PPQ1NPPP/R3KB1R',
        comment: 'defends the f3 and develops another peice',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'c6',
        moveTo: 'e5',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/1bP1n2q/2N1B3/PPQ1NPPP/R3KB1R',
        comment: 'trying to win the hanging pawn on c4',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 18,
        moveFrom: 'g2',
        moveTo: 'g3',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/1bP1n2q/2N1B1P1/PPQ1NP1P/R3KB1R',
        comment:
          "ignoring the capture on c4 and checking the queen. Right now black's center is very weak.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'e4',
        moveTo: 'c3',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/1bP4q/2n1B1P1/PPQ1NP1P/R3KB1R',
        comment:
          'This helps white by freeing his position. Also this trade is a bad trade for black because he is giving up his good knight for a inferior one and allowing white to place his other knight on superior square. Nf3  would have been very tough for white to defend',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 20,
        moveFrom: 'e2',
        moveTo: 'c3',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/1bP4q/2N1B1P1/PPQ2P1P/R3KB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'b4',
        moveTo: 'c3',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/2P4q/2b1B1P1/PPQ2P1P/R3KB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'c2',
        moveTo: 'c3',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/2P4q/2Q1B1P1/PP3P1P/R3KB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'h4',
        moveTo: 'e4',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/2P1q3/2Q1B1P1/PP3P1P/R3KB1R',
        comment:
          'Black wins the rook but he will have to waste valuable time getting his queen back in the game. In contrast white is almost completely mobilized and Black has not even castle yet. Black also has the problem of his light bishop being stuck on it original square. In conclusion white is doing better here and has more than enough compensation for the rook',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'e1',
        moveTo: 'c1',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/2P1q3/2Q1B1P1/PP3P1P/2KR1B1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'e4',
        moveTo: 'h1',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4n3/2P5/2Q1B1P1/PP3P1P/2KR1B1q',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'c3',
        moveTo: 'e5',
        fen: 'r1b1k2r/pp1p1ppp/4p3/4Q3/2P5/4B1P1/PP3P1P/2KR1B1q',
        comment: 'Black is positionally bankrupt.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'r1b2rk1/pp1p1ppp/4p3/4Q3/2P5/4B1P1/PP3P1P/2KR1B1q',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 28,
        moveFrom: 'f1',
        moveTo: 'd3',
        fen: 'r1b2rk1/pp1p1ppp/4p3/4Q3/2P5/3BB1P1/PP3P1P/2KR3q',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 29,
        moveFrom: 'h1',
        moveTo: 'f3',
        fen: 'r1b2rk1/pp1p1ppp/4p3/4Q3/2P5/3BBqP1/PP3P1P/2KR4',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 30,
        moveFrom: 'e3',
        moveTo: 'c5',
        fen: 'r1b2rk1/pp1p1ppp/4p3/2B1Q3/2P5/3B1qP1/PP3P1P/2KR4',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 31,
        moveFrom: 'd7',
        moveTo: 'd6',
        fen: 'r1b2rk1/pp3ppp/3pp3/2B1Q3/2P5/3B1qP1/PP3P1P/2KR4',
        comment: 'this is a wasted move better is the immediate Re8',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 32,
        moveFrom: 'c5',
        moveTo: 'd6',
        fen: 'r1b2rk1/pp3ppp/3Bp3/4Q3/2P5/3B1qP1/PP3P1P/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'f8',
        moveTo: 'd8',
        fen: 'r1br2k1/pp3ppp/3Bp3/4Q3/2P5/3B1qP1/PP3P1P/2KR4',
        comment:
          'The point of d6 is that white can not move the bishop because of the threat of Rxd3 winning the bishop.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'e5',
        moveTo: 'e4',
        fen: 'r1br2k1/pp3ppp/3Bp3/8/2P1Q3/3B1qP1/PP3P1P/2KR4',
        comment:
          'The exchange of queens is favorable for white. This removes the last active piece for black',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'f3',
        moveTo: 'h5',
        fen: 'r1br2k1/pp3ppp/3Bp3/7q/2P1Q3/3B2P1/PP3P1P/2KR4',
        comment:
          'black can not afford to give up his queen so is forced to make another positional consession',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 36,
        moveFrom: 'e4',
        moveTo: 'e2',
        fen: 'r1br2k1/pp3ppp/3Bp3/7q/2P5/3B2P1/PP2QP1P/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 37,
        moveFrom: 'h5',
        moveTo: 'h2',
        fen: 'r1br2k1/pp3ppp/3Bp3/8/2P5/3B2P1/PP2QP1q/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 38,
        moveFrom: 'd6',
        moveTo: 'e5',
        fen: 'r1br2k1/pp3ppp/4p3/4B3/2P5/3B2P1/PP2QP1q/2KR4',
        comment: 'My bishops are well placed and dominating the board',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 39,
        moveFrom: 'h2',
        moveTo: 'h6',
        fen: 'r1br2k1/pp3ppp/4p2q/4B3/2P5/3B2P1/PP2QP2/2KR4',
        comment: 'A bad move that dooms the queen',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 40,
        moveFrom: 'f2',
        moveTo: 'f4',
        fen: 'r1br2k1/pp3ppp/4p2q/4B3/2P2P2/3B2P1/PP2Q3/2KR4',
        comment: '!! now the queen is locked is a virtual prison',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'f7',
        moveTo: 'f5',
        fen: 'r1br2k1/pp4pp/4p2q/4Bp2/2P2P2/3B2P1/PP2Q3/2KR4',
        comment:
          'another bad move that creates a weakness on e6 that will be very difficult to defend',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 42,
        moveFrom: 'd3',
        moveTo: 'c2',
        fen: 'r1br2k1/pp4pp/4p2q/4Bp2/2P2P2/6P1/PPB1Q3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 43,
        moveFrom: 'd8',
        moveTo: 'd7',
        fen: 'r1b3k1/pp1r2pp/4p2q/4Bp2/2P2P2/6P1/PPB1Q3/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 44,
        moveFrom: 'e2',
        moveTo: 'f3',
        fen: 'r1b3k1/pp1r2pp/4p2q/4Bp2/2P2P2/5QP1/PPB5/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 45,
        moveFrom: 'h6',
        moveTo: 'g6',
        fen: 'r1b3k1/pp1r2pp/4p1q1/4Bp2/2P2P2/5QP1/PPB5/2KR4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 46,
        moveFrom: 'd1',
        moveTo: 'd7',
        fen: 'r1b3k1/pp1R2pp/4p1q1/4Bp2/2P2P2/5QP1/PPB5/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 47,
        moveFrom: 'c8',
        moveTo: 'd7',
        fen: 'r5k1/pp1b2pp/4p1q1/4Bp2/2P2P2/5QP1/PPB5/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 48,
        moveFrom: 'f3',
        moveTo: 'b7',
        fen: 'r5k1/pQ1b2pp/4p1q1/4Bp2/2P2P2/6P1/PPB5/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 49,
        moveFrom: 'g6',
        moveTo: 'e8',
        fen: 'r3q1k1/pQ1b2pp/4p3/4Bp2/2P2P2/6P1/PPB5/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 50,
        moveFrom: 'c2',
        moveTo: 'a4',
        fen: 'r3q1k1/pQ1b2pp/4p3/4Bp2/B1P2P2/6P1/PP6/2K5',
        comment: 'the bishop is pinned on d7 because of the mate on g7',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 51,
        moveFrom: 'a8',
        moveTo: 'd8',
        fen: '3rq1k1/pQ1b2pp/4p3/4Bp2/B1P2P2/6P1/PP6/2K5',
        comment: 'defending the weak d7 square. Black is completely tied down to defense',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'b2',
        moveTo: 'b4',
        fen: '3rq1k1/pQ1b2pp/4p3/4Bp2/BPP2P2/6P1/P7/2K5',
        comment:
          'with black tied down to the defense of d7 there is no way he can stop the last march of the pawns',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 53,
        moveFrom: 'e8',
        moveTo: 'f7',
        fen: '3r2k1/pQ1b1qpp/4p3/4Bp2/BPP2P2/6P1/P7/2K5',
        comment: 'seeking a more active square for the queen',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 54,
        moveFrom: 'b7',
        moveTo: 'c7',
        fen: '3r2k1/p1Qb1qpp/4p3/4Bp2/BPP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 55,
        moveFrom: 'f7',
        moveTo: 'e7',
        fen: '3r2k1/p1Qbq1pp/4p3/4Bp2/BPP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 56,
        moveFrom: 'a4',
        moveTo: 'c6',
        fen: '3r2k1/p1Qbq1pp/2B1p3/4Bp2/1PP2P2/6P1/P7/2K5',
        comment:
          'The pawn move c5? would be met with 29. ...Kf7 30. Qxa7 Bxa4! and the game is drawn',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 57,
        moveFrom: 'g8',
        moveTo: 'f7',
        fen: '3r4/p1Qbqkpp/2B1p3/4Bp2/1PP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'e5',
        moveTo: 'd6',
        fen: '3r4/p1Qbqkpp/2BBp3/5p2/1PP2P2/6P1/P7/2K5',
        comment: 'preventing black from penatrating into the queenside.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'e7',
        moveTo: 'e8',
        fen: '3rq3/p1Qb1kpp/2BBp3/5p2/1PP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 60,
        moveFrom: 'c7',
        moveTo: 'a7',
        fen: '3rq3/Q2b1kpp/2BBp3/5p2/1PP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'f7',
        moveTo: 'g6',
        fen: '3rq3/Q2b2pp/2BBp1k1/5p2/1PP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'd6',
        moveTo: 'e5',
        fen: '3rq3/Q2b2pp/2B1p1k1/4Bp2/1PP2P2/6P1/P7/2K5',
        comment:
          'reestablishing the pin on d7. However white could ahve also played Bxd7 but sometimes it is better to keep the threat hanging over their head.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: '3rq3/Q2b2p1/2B1p1kp/4Bp2/1PP2P2/6P1/P7/2K5',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 64,
        moveFrom: 'c6',
        moveTo: 'f3',
        fen: '3rq3/Q2b2p1/4p1kp/4Bp2/1PP2P2/5BP1/P7/2K5',
        comment: 'white can not play a4 because now his king is safe after 33. ...Bxc6',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 65,
        moveFrom: 'g6',
        moveTo: 'h7',
        fen: '3rq3/Q2b2pk/4p2p/4Bp2/1PP2P2/5BP1/P7/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 66,
        moveFrom: 'c4',
        moveTo: 'c5',
        fen: '3rq3/Q2b2pk/4p2p/2P1Bp2/1P3P2/5BP1/P7/2K5',
        comment: 'threatening to play c3',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'e8',
        moveTo: 'f8',
        fen: '3r1q2/Q2b2pk/4p2p/2P1Bp2/1P3P2/5BP1/P7/2K5',
        comment: 'Defends against c3',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 68,
        moveFrom: 'a2',
        moveTo: 'a4',
        fen: '3r1q2/Q2b2pk/4p2p/2P1Bp2/PP3P2/5BP1/8/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'd7',
        moveTo: 'c8',
        fen: '2br1q2/Q5pk/4p2p/2P1Bp2/PP3P2/5BP1/8/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'c1',
        moveTo: 'c2',
        fen: '2br1q2/Q5pk/4p2p/2P1Bp2/PP3P2/5BP1/2K5/8',
        comment:
          'As lasker taught us. The king is your most powerful piece in the endgame. As a rule try and be the first one to the center.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 71,
        moveFrom: 'c8',
        moveTo: 'd7',
        fen: '3r1q2/Q2b2pk/4p2p/2P1Bp2/PP3P2/5BP1/2K5/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 72,
        moveFrom: 'b4',
        moveTo: 'b5',
        fen: '3r1q2/Q2b2pk/4p2p/1PP1Bp2/P4P2/5BP1/2K5/8',
        comment:
          'limiting the scope of the bishop and threatening c6 with massive force. In the endgame I play very logical and methodical',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 73,
        moveFrom: 'd7',
        moveTo: 'c8',
        fen: '2br1q2/Q5pk/4p2p/1PP1Bp2/P4P2/5BP1/2K5/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 74,
        moveFrom: 'c5',
        moveTo: 'c6',
        fen: '2br1q2/Q5pk/2P1p2p/1P2Bp2/P4P2/5BP1/2K5/8',
        comment:
          'a small blunder that allows black to create some small counter play. Better was Qc7',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 75,
        moveFrom: 'h7',
        moveTo: 'g6',
        fen: '2br1q2/Q5p1/2P1p1kp/1P2Bp2/P4P2/5BP1/2K5/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 76,
        moveFrom: 'e5',
        moveTo: 'c3',
        fen: '2br1q2/Q5p1/2P1p1kp/1P3p2/P4P2/2B2BP1/2K5/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 77,
        moveFrom: 'e6',
        moveTo: 'e5',
        fen: '2br1q2/Q5p1/2P3kp/1P2pp2/P4P2/2B2BP1/2K5/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 78,
        moveFrom: 'c3',
        moveTo: 'e5',
        fen: '2br1q2/Q5p1/2P3kp/1P2Bp2/P4P2/5BP1/2K5/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 79,
        moveFrom: 'f8',
        moveTo: 'g8',
        fen: '2br2q1/Q5p1/2P3kp/1P2Bp2/P4P2/5BP1/2K5/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 80,
        moveFrom: 'c2',
        moveTo: 'c3',
        fen: '2br2q1/Q5p1/2P3kp/1P2Bp2/P4P2/2K2BP1/8/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 81,
        moveFrom: 'g8',
        moveTo: 'f8',
        fen: '2br1q2/Q5p1/2P3kp/1P2Bp2/P4P2/2K2BP1/8/8',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 82,
        moveFrom: 'f3',
        moveTo: 'e2',
        fen: '2br1q2/Q5p1/2P3kp/1P2Bp2/P4P2/2K3P1/4B3/8',
        comment:
          'A better idea for white is to force the exchange of queens with Qxg7  with the pawns so far advanced win would have an easy win',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 83,
        moveFrom: 'f8',
        moveTo: 'a3',
        fen: '2br4/Q5p1/2P3kp/1P2Bp2/P4P2/q1K3P1/4B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 84,
        moveFrom: 'c3',
        moveTo: 'c2',
        fen: '2br4/Q5p1/2P3kp/1P2Bp2/P4P2/q5P1/2K1B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 85,
        moveFrom: 'a3',
        moveTo: 'a2',
        fen: '2br4/Q5p1/2P3kp/1P2Bp2/P4P2/6P1/q1K1B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 86,
        moveFrom: 'e5',
        moveTo: 'b2',
        fen: '2br4/Q5p1/2P3kp/1P3p2/P4P2/6P1/qBK1B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 87,
        moveFrom: 'd8',
        moveTo: 'g8',
        fen: '2b3r1/Q5p1/2P3kp/1P3p2/P4P2/6P1/qBK1B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 88,
        moveFrom: 'a7',
        moveTo: 'd4',
        fen: '2b3r1/6p1/2P3kp/1P3p2/P2Q1P2/6P1/qBK1B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 89,
        moveFrom: 'c8',
        moveTo: 'e6',
        fen: '6r1/6p1/2P1b1kp/1P3p2/P2Q1P2/6P1/qBK1B3/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 90,
        moveFrom: 'e2',
        moveTo: 'd3',
        fen: '6r1/6p1/2P1b1kp/1P3p2/P2Q1P2/3B2P1/qBK5/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 91,
        moveFrom: 'g6',
        moveTo: 'h5',
        fen: '6r1/6p1/2P1b2p/1P3p1k/P2Q1P2/3B2P1/qBK5/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 92,
        moveFrom: 'c6',
        moveTo: 'c7',
        fen: '6r1/2P3p1/4b2p/1P3p1k/P2Q1P2/3B2P1/qBK5/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 93,
        moveFrom: 'a2',
        moveTo: 'b3',
        fen: '6r1/2P3p1/4b2p/1P3p1k/P2Q1P2/1q1B2P1/1BK5/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 94,
        moveFrom: 'c2',
        moveTo: 'c1',
        fen: '6r1/2P3p1/4b2p/1P3p1k/P2Q1P2/1q1B2P1/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 95,
        moveFrom: 'h5',
        moveTo: 'g4',
        fen: '6r1/2P3p1/4b2p/1P3p2/P2Q1Pk1/1q1B2P1/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 96,
        moveFrom: 'b5',
        moveTo: 'b6',
        fen: '6r1/2P3p1/1P2b2p/5p2/P2Q1Pk1/1q1B2P1/1B6/2K5',
        comment:
          'white has nothing in trying to push the mate. Instead I go for the sure win which is promoting the pawn',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 97,
        moveFrom: 'g8',
        moveTo: 'c8',
        fen: '2r5/2P3p1/1P2b2p/5p2/P2Q1Pk1/1q1B2P1/1B6/2K5',
        comment: 'with the rook on c8 it is now mate.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 98,
        moveFrom: 'd4',
        moveTo: 'g7',
        fen: '2r5/2P3Q1/1P2b2p/5p2/P4Pk1/1q1B2P1/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 99,
        moveFrom: 'g4',
        moveTo: 'h3',
        fen: '2r5/2P3Q1/1P2b2p/5p2/P4P2/1q1B2Pk/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 100,
        moveFrom: 'g7',
        moveTo: 'd4',
        fen: '2r5/2P5/1P2b2p/5p2/P2Q1P2/1q1B2Pk/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 101,
        moveFrom: 'c8',
        moveTo: 'g8',
        fen: '6r1/2P5/1P2b2p/5p2/P2Q1P2/1q1B2Pk/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 102,
        moveFrom: 'd3',
        moveTo: 'e2',
        fen: '6r1/2P5/1P2b2p/5p2/P2Q1P2/1q4Pk/1B2B3/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 103,
        moveFrom: 'g8',
        moveTo: 'a8',
        fen: 'r7/2P5/1P2b2p/5p2/P2Q1P2/1q4Pk/1B2B3/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 104,
        moveFrom: 'e2',
        moveTo: 'f1',
        fen: 'r7/2P5/1P2b2p/5p2/P2Q1P2/1q4Pk/1B6/2K2B2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 105,
        moveFrom: 'h3',
        moveTo: 'g4',
        fen: 'r7/2P5/1P2b2p/5p2/P2Q1Pk1/1q4P1/1B6/2K2B2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 106,
        moveFrom: 'f1',
        moveTo: 'b5',
        fen: 'r7/2P5/1P2b2p/1B3p2/P2Q1Pk1/1q4P1/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 107,
        moveFrom: 'e6',
        moveTo: 'd5',
        fen: 'r7/2P5/1P5p/1B1b1p2/P2Q1Pk1/1q4P1/1B6/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 108,
        moveFrom: 'b5',
        moveTo: 'e2',
        fen: 'r7/2P5/1P5p/3b1p2/P2Q1Pk1/1q4P1/1B2B3/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 109,
        moveFrom: 'g4',
        moveTo: 'g3',
        fen: 'r7/2P5/1P5p/3b1p2/P2Q1P2/1q4k1/1B2B3/2K5',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 110,
        moveFrom: 'd4',
        moveTo: 'g1',
        fen: 'r7/2P5/1P5p/3b1p2/P4P2/1q4k1/1B2B3/2K3Q1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 111,
        moveFrom: 'g3',
        moveTo: 'h3',
        fen: 'r7/2P5/1P5p/3b1p2/P4P2/1q5k/1B2B3/2K3Q1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 112,
        moveFrom: 'e2',
        moveTo: 'f1',
        fen: 'r7/2P5/1P5p/3b1p2/P4P2/1q5k/1B6/2K2BQ1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 113,
        moveFrom: 'h3',
        moveTo: 'h4',
        fen: 'r7/2P5/1P5p/3b1p2/P4P1k/1q6/1B6/2K2BQ1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 114,
        moveFrom: 'b2',
        moveTo: 'f6',
        fen: 'r7/2P5/1P3B1p/3b1p2/P4P1k/1q6/8/2K2BQ1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 115,
        moveFrom: 'h4',
        moveTo: 'h5',
        fen: 'r7/2P5/1P3B1p/3b1p1k/P4P2/1q6/8/2K2BQ1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 116,
        moveFrom: 'f1',
        moveTo: 'e2',
        fen: 'r7/2P5/1P3B1p/3b1p1k/P4P2/1q6/4B3/2K3Q1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 117,
        moveFrom: 'd5',
        moveTo: 'f3',
        fen: 'r7/2P5/1P3B1p/5p1k/P4P2/1q3b2/4B3/2K3Q1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 118,
        moveFrom: 'g1',
        moveTo: 'h1',
        fen: 'r7/2P5/1P3B1p/5p1k/P4P2/1q3b2/4B3/2K4Q',
        comment: 'Black finally realizes that his fate was decided 14 moves ago.',
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 7,
    name: "[Tournament] The Bishop's Opening (About greedy queens and powerful f-files)",
    accuracyPercentage: 0.676923076923077,
    recallPercentage: 1,
    precisionPercentage: 0.19230769230769232,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: "'Best by test.' -- Bobby Fischer",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e5',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 2,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR',
        comment:
          "The bishop's game, my new beloved opening against open games for almost a year now. While there's not tons of theory to learn, it's perfectly solid and playable, though not seen in top level chess anymore. After the usual 2. Nf3, Black still can choose between a variety of openings (...Nc6, ...Nf6, ...d6) where White has to be prepared. The bishop's opening often transposes to King's Bishop's gambit (1. e4 e5 2. f4 exf4 3. Bc4), a very fun opening but one that is, directly played, too dangerous for me in tournament play. Also there is an affinity to the Vienna game (1. e4 e5 2. Nc3).",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR',
        comment: "The usual response called 'Berlin Defense', developing and attacking the pawn.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'd2',
        moveTo: 'd3',
        fen: 'rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR',
        comment:
          'Solid, simple. Interesting to mention here is the existence of the sharp Urusov gambit 3. d4.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'rnbqkb1r/pppp1pp1/5n1p/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR',
        comment: '?! preventing Bg5, but losing tempo for development',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 6,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqkb1r/pppp1pp1/5n1p/4p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR',
        comment:
          "Continuing to develop; I prefer Nc3 over Nf3 in this position as it keeps open a possible f4 pawn thrust (in the spirit of King's Gambit and the Vienna game).",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'f8',
        moveTo: 'c5',
        fen: 'rnbqk2r/pppp1pp1/5n1p/2b1p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR',
        comment: "Completing king's side development and preparing to castle.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'c1',
        moveTo: 'e3',
        fen: 'rnbqk2r/pppp1pp1/5n1p/2b1p3/2B1P3/2NPB3/PPP2PPP/R2QK1NR',
        comment:
          '!? Offering a bishop exchange with the idea of opening the f-file (my favourite file ;-)) and strengthening the centre with another pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'c5',
        moveTo: 'e3',
        fen: 'rnbqk2r/pppp1pp1/5n1p/4p3/2B1P3/2NPb3/PPP2PPP/R2QK1NR',
        comment:
          'Interestingly enough, Black accepts the offer. I would have expected ...Bb6, himself offering an exchange again for opening the a-file.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 10,
        moveFrom: 'f2',
        moveTo: 'e3',
        fen: 'rnbqk2r/pppp1pp1/5n1p/4p3/2B1P3/2NPP3/PPP3PP/R2QK1NR',
        comment:
          "I was happy with this position, though being aware that the pawn e3 is a potential weakness -- for having an open file, that's okay.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'd7',
        moveTo: 'd6',
        fen: 'rnbqk2r/ppp2pp1/3p1n1p/4p3/2B1P3/2NPP3/PPP3PP/R2QK1NR',
        comment: 'Freeing the light-squared bishop.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbqk2r/ppp2pp1/3p1n1p/4p3/2B1P3/2NPPN2/PPP3PP/R2QK2R',
        comment: 'Completes piece development',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'c7',
        moveTo: 'c6',
        fen: 'rnbqk2r/pp3pp1/2pp1n1p/4p3/2B1P3/2NPPN2/PPP3PP/R2QK2R',
        comment:
          'I was wondering why Black, already behind in development, is wasting time with another pawn move. Not thinking further about it, I quickly...',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'rnbqk2r/pp3pp1/2pp1n1p/4p3/2B1P3/2NPPN2/PPP3PP/R2Q1RK1',
        comment: '...castled and herewith occupied the open file with the rook.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'd8',
        moveTo: 'b6',
        fen: 'rnb1k2r/pp3pp1/1qpp1n1p/4p3/2B1P3/2NPPN2/PPP3PP/R2Q1RK1',
        comment:
          "Damn, I overlooked this simple double attack tactics which obviously tries to win a pawn and already exploits the backwards pawn weakness! As I am far ahead in development, it isn't that bad, but still a decision has to be made: Save the pawns or sacrifice one and continue with the own plans?",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 16,
        moveFrom: 'd1',
        moveTo: 'd2',
        fen: 'rnb1k2r/pp3pp1/1qpp1n1p/4p3/2B1P3/2NPPN2/PPPQ2PP/R4RK1',
        comment:
          "I decided for not caring about a lost pawn, as Black loses only more time with this and even opens me another file. It isn't healthy to go for pawn-eating with the queen in the early development stage, is an important rule in chess, why should the opponent be able to break this rule? The rooks are already connected and development is completed, it takes Black at least three more moves to achieve this! The other option would have been Qc1 which defends both pawns, but then ...Ng4 Re1 results in a cramped position.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'b6',
        moveTo: 'b2',
        fen: 'rnb1k2r/pp3pp1/2pp1n1p/4p3/2B1P3/2NPPN2/PqPQ2PP/R4RK1',
        comment:
          'A critical position, now White has to be quick in pushing his agenda to not being left with a pawn less in the end!',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'd3',
        moveTo: 'd4',
        fen: 'rnb1k2r/pp3pp1/2pp1n1p/4p3/2BPP3/2N1PN2/PqPQ2PP/R4RK1',
        comment:
          "As all pieces have already good positions, it's time to crack up the center. Rab1 before would have also been possible, is maybe even more precise.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 19,
        moveFrom: 'e5',
        moveTo: 'd4',
        fen: 'rnb1k2r/pp3pp1/2pp1n1p/8/2BpP3/2N1PN2/PqPQ2PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'e3',
        moveTo: 'd4',
        fen: 'rnb1k2r/pp3pp1/2pp1n1p/8/2BPP3/2N2N2/PqPQ2PP/R4RK1',
        comment:
          'Obviously, White wants to continue with e5, driving away the knight in turn to exploit the weak f7 point.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'b2',
        moveTo: 'b4',
        fen: 'rnb1k2r/pp3pp1/2pp1n1p/8/1qBPP3/2N2N2/P1PQ2PP/R4RK1',
        comment:
          "Attacks my bishop and pins the knight -- though the pin can't be directly exploited in this case (not even after castling), as ...Nxe4 Nxe4 results in a position where the queen is defended.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'c4',
        moveTo: 'b3',
        fen: 'rnb1k2r/pp3pp1/2pp1n1p/8/1q1PP3/1BN2N2/P1PQ2PP/R4RK1',
        comment:
          "This bishop has reached it's dream spot and will not move anymore for the rest of the game ;-) Bxf7+ was very tempting at this point, following with e5 and using the open f-file, but I wasn't sure if it would really work out.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'rnb2rk1/pp3pp1/2pp1n1p/8/1q1PP3/1BN2N2/P1PQ2PP/R4RK1',
        comment: 'Finally, Black gets his king into safety.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'a1',
        moveTo: 'b1',
        fen: 'rnb2rk1/pp3pp1/2pp1n1p/8/1q1PP3/1BN2N2/P1PQ2PP/1R3RK1',
        comment:
          'Occupying the file with tempo, as this threatens the simple Bxf7+ following a queen loss for white.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'b4',
        moveTo: 'a5',
        fen: 'rnb2rk1/pp3pp1/2pp1n1p/q7/3PP3/1BN2N2/P1PQ2PP/1R3RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'e4',
        moveTo: 'e5',
        fen: 'rnb2rk1/pp3pp1/2pp1n1p/q3P3/3P4/1BN2N2/P1PQ2PP/1R3RK1',
        comment:
          "That seemed to be the only move that makes sense in this position, further opening up the centre. I'm not sure whether White really is better in this position, I guess with precise play Black can defend and catch up in development?!",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'd6',
        moveTo: 'e5',
        fen: 'rnb2rk1/pp3pp1/2p2n1p/q3p3/3P4/1BN2N2/P1PQ2PP/1R3RK1',
        comment: 'Take with pawn or knight, that is the question now...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 28,
        moveFrom: 'd4',
        moveTo: 'e5',
        fen: 'rnb2rk1/pp3pp1/2p2n1p/q3P3/8/1BN2N2/P1PQ2PP/1R3RK1',
        comment:
          'I found this move to be more dynamic (opens d-file and drives away the knight), though it creates a pawn structure weakness in form of an isolated pawn.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'f6',
        moveTo: 'g4',
        fen: 'rnb2rk1/pp3pp1/2p4p/q3P3/6n1/1BN2N2/P1PQ2PP/1R3RK1',
        comment:
          'Somehow I have overlooked that with this move, the pawn is hanging... the rook has to come to help',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 30,
        moveFrom: 'b1',
        moveTo: 'e1',
        fen: 'rnb2rk1/pp3pp1/2p4p/q3P3/6n1/1BN2N2/P1PQ2PP/4RRK1',
        comment:
          'At this point, only at move 16, we both have already consumed approx. 1 hour of our time! Obviously, White wants to continue with h3, winning a piece.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'c8',
        moveTo: 'e6',
        fen: 'rn3rk1/pp3pp1/2p1b2p/q3P3/6n1/1BN2N2/P1PQ2PP/4RRK1',
        comment:
          "The second move which surprised me, I overlooked that Black can simply enforce an exchange of bishops! Now Bxe6 fxe6, h3 was the first tactic which came to my mind, but this doesn't work out since ...Rd8 drives my queen away and allows my knight on c3 to be taken. Instead I tried to prevent the exchange with...",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 32,
        moveFrom: 'e1',
        moveTo: 'e4',
        fen: 'rn3rk1/pp3pp1/2p1b2p/q3P3/4R1n1/1BN2N2/P1PQ2PP/5RK1',
        comment:
          '...this interesting move! If Black takes my bishop, I can simply take the knight with the following threat of Qxh6. The second important purpose of this move is to make space for the queen to leave the d-file, where she can still defend the knight on c3 (on e1).',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 33,
        moveFrom: 'f8',
        moveTo: 'd8',
        fen: 'rn1r2k1/pp3pp1/2p1b2p/q3P3/4R1n1/1BN2N2/P1PQ2PP/5RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'd2',
        moveTo: 'e1',
        fen: 'rn1r2k1/pp3pp1/2p1b2p/q3P3/4R1n1/1BN2N2/P1P3PP/4QRK1',
        comment: "White's threat is now Bishop exchange, following Rxg4.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'a5',
        moveTo: 'b6',
        fen: 'rn1r2k1/pp3pp1/1qp1b2p/4P3/4R1n1/1BN2N2/P1P3PP/4QRK1',
        comment: 'A check in-between, unexpected but not having any unpleasing consequences.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 36,
        moveFrom: 'g1',
        moveTo: 'h1',
        fen: 'rn1r2k1/pp3pp1/1qp1b2p/4P3/4R1n1/1BN2N2/P1P3PP/4QR1K',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 37,
        moveFrom: 'e6',
        moveTo: 'f5',
        fen: 'rn1r2k1/pp3pp1/1qp4p/4Pb2/4R1n1/1BN2N2/P1P3PP/4QR1K',
        comment:
          '? Black should definitely have taken my bishop here to get rid of one of my best pieces, incessantly eyeing the weak f7 point.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 38,
        moveFrom: 'c3',
        moveTo: 'a4',
        fen: 'rn1r2k1/pp3pp1/1qp4p/4Pb2/N3R1n1/1B3N2/P1P3PP/4QR1K',
        comment:
          'Driving the queen away from the a7/g1 diagonal, for preparing Rf4 without letting ...Ne3 happen. Bxf7+! would have probably been stronger, following with Na4 if the king takes.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 39,
        moveFrom: 'b6',
        moveTo: 'a6',
        fen: 'rn1r2k1/pp3pp1/q1p4p/4Pb2/N3R1n1/1B3N2/P1P3PP/4QR1K',
        comment:
          'Okay, after Rf4, ...Ne3 is still possible now, since a following Qxe3 would result in ...Qxf1+. But anyway, why not giving away the Exchange for an awesome position?',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'e4',
        moveTo: 'f4',
        fen: 'rn1r2k1/pp3pp1/q1p4p/4Pb2/N4Rn1/1B3N2/P1P3PP/4QR1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'g4',
        moveTo: 'e3',
        fen: 'rn1r2k1/pp3pp1/q1p4p/4Pb2/N4R2/1B2nN2/P1P3PP/4QR1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'e1',
        moveTo: 'e3',
        fen: 'rn1r2k1/pp3pp1/q1p4p/4Pb2/N4R2/1B2QN2/P1P3PP/5R1K',
        comment:
          'Happily giving away the back-rank rook, knowing that I will soon get another piece for it.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 43,
        moveFrom: 'a6',
        moveTo: 'f1',
        fen: 'rn1r2k1/pp3pp1/2p4p/4Pb2/N4R2/1B2QN2/P1P3PP/5q1K',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'f3',
        moveTo: 'g1',
        fen: 'rn1r2k1/pp3pp1/2p4p/4Pb2/N4R2/1B2Q3/P1P3PP/5qNK',
        comment:
          'The queen has to leave again, and the bishop is eaten on the next move, with huge pressure on f7.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'f1',
        moveTo: 'b5',
        fen: 'rn1r2k1/pp3pp1/2p4p/1q2Pb2/N4R2/1B2Q3/P1P3PP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 46,
        moveFrom: 'f4',
        moveTo: 'f5',
        fen: 'rn1r2k1/pp3pp1/2p4p/1q2PR2/N7/1B2Q3/P1P3PP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 47,
        moveFrom: 'd8',
        moveTo: 'f8',
        fen: 'rn3rk1/pp3pp1/2p4p/1q2PR2/N7/1B2Q3/P1P3PP/6NK',
        comment: 'This rook is doomed to passivity now.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 48,
        moveFrom: 'e3',
        moveTo: 'f2',
        fen: 'rn3rk1/pp3pp1/2p4p/1q2PR2/N7/1B6/P1P2QPP/6NK',
        comment:
          'Increasing the pressure on the f-file and defending the rook, enabling the covered queen attack e6.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 49,
        moveFrom: 'b8',
        moveTo: 'a6',
        fen: 'r4rk1/pp3pp1/n1p4p/1q2PR2/N7/1B6/P1P2QPP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 50,
        moveFrom: 'e5',
        moveTo: 'e6',
        fen: 'r4rk1/pp3pp1/n1p1P2p/1q3R2/N7/1B6/P1P2QPP/6NK',
        comment: 'Again, poor queen has to move.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 51,
        moveFrom: 'b5',
        moveTo: 'b4',
        fen: 'r4rk1/pp3pp1/n1p1P2p/5R2/Nq6/1B6/P1P2QPP/6NK',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'e6',
        moveTo: 'f7',
        fen: 'r4rk1/pp3Pp1/n1p4p/5R2/Nq6/1B6/P1P2QPP/6NK',
        comment:
          'This pawn is like a rock (if Black is not able to catch the bishop with the knight or wants to give away material) and will prove to be VERY useful in the rest of the game.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 53,
        moveFrom: 'g8',
        moveTo: 'h8',
        fen: 'r4r1k/pp3Pp1/n1p4p/5R2/Nq6/1B6/P1P2QPP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 54,
        moveFrom: 'a4',
        moveTo: 'b2',
        fen: 'r4r1k/pp3Pp1/n1p4p/5R2/1q6/1B6/PNP2QPP/6NK',
        comment: 'The knight needs to get back into the game.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 55,
        moveFrom: 'b4',
        moveTo: 'c3',
        fen: 'r4r1k/pp3Pp1/n1p4p/5R2/8/1Bq5/PNP2QPP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'b2',
        moveTo: 'd3',
        fen: 'r4r1k/pp3Pp1/n1p4p/5R2/8/1BqN4/P1P2QPP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'a8',
        moveTo: 'd8',
        fen: '3r1r1k/pp3Pp1/n1p4p/5R2/8/1BqN4/P1P2QPP/6NK',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'h2',
        moveTo: 'h3',
        fen: '3r1r1k/pp3Pp1/n1p4p/5R2/8/1BqN3P/P1P2QP1/6NK',
        comment:
          'Not sure if this was really necessary already (I was worrying the queen check on a1), either Qxa7 or the fork threatening Ne5 would have been stronger probably.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'd8',
        moveTo: 'd6',
        fen: '5r1k/pp3Pp1/n1pr3p/5R2/8/1BqN3P/P1P2QP1/6NK',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 60,
        moveFrom: 'd3',
        moveTo: 'e5',
        fen: '5r1k/pp3Pp1/n1pr3p/4NR2/8/1Bq4P/P1P2QP1/6NK',
        comment: 'This should have happened one move earlier!',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 61,
        moveFrom: 'b7',
        moveTo: 'b6',
        fen: '5r1k/p4Pp1/nppr3p/4NR2/8/1Bq4P/P1P2QP1/6NK',
        comment: 'Black is worried about losing pawns...',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 62,
        moveFrom: 'g1',
        moveTo: 'e2',
        fen: '5r1k/p4Pp1/nppr3p/4NR2/8/1Bq4P/P1P1NQP1/7K',
        comment: 'Getting the other knight into the action as well.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'c3',
        moveTo: 'a1',
        fen: '5r1k/p4Pp1/nppr3p/4NR2/8/1B5P/P1P1NQP1/q6K',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 64,
        moveFrom: 'h1',
        moveTo: 'h2',
        fen: '5r1k/p4Pp1/nppr3p/4NR2/8/1B5P/P1P1NQPK/q7',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 65,
        moveFrom: 'g7',
        moveTo: 'g6',
        fen: '5r1k/p4P2/nppr2pp/4NR2/8/1B5P/P1P1NQPK/q7',
        comment:
          'I was truly shocked and paralysed by this move -- another one which I have completely overlooked! It looks as like White is losing a piece by force now: The rook is obviously attacked by the pawn and has to move along the f-file, but then this leaves the knight on e5 undefended and the queen can happily eat it. Already thinking about to resign, I luckily found the saving move.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 66,
        moveFrom: 'f2',
        moveTo: 'g3',
        fen: '5r1k/p4P2/nppr2pp/4NR2/8/1B4QP/P1P1N1PK/q7',
        comment:
          "That's funny: Black can't open the g-file now as this would immediately result in a mate in two, through a quick queen-sacrifice-and-rebirth (Qg8+ Rxg8 fxg8=D#). The bishop is proving to be extremely effective for White, Black would have better exchanged it!",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'h8',
        moveTo: 'h7',
        fen: '5r2/p4P1k/nppr2pp/4NR2/8/1B4QP/P1P1N1PK/q7',
        comment: 'Protects the pawn on g6 which is attacked twice by White now.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 68,
        moveFrom: 'e2',
        moveTo: 'f4',
        fen: '5r2/p4P1k/nppr2pp/4NR2/5N2/1B4QP/P1P3PK/q7',
        comment: 'Thrice! Notice that eating the rook is still not possible for Black.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'g6',
        moveTo: 'g5',
        fen: '5r2/p4P1k/nppr3p/4NRp1/5N2/1B4QP/P1P3PK/q7',
        comment:
          'Trying to keep the files closed. At this point of the game we both had only a few minutes left (before the 40 moves boundary) and had to move rather quickly.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'f4',
        moveTo: 'h5',
        fen: '5r2/p4P1k/nppr3p/4NRpN/8/1B4QP/P1P3PK/q7',
        comment:
          "The safe way to play it -- the rook sacrifice Rxg5! had clearly to be considered, as it looks like after ...hxg5, Qxg5 there is no way to avoid mate anymore for Black, but being in time pressure I wasn't 100% sure if it really works out, so I decided to move the knight.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 71,
        moveFrom: 'd6',
        moveTo: 'd1',
        fen: '5r2/p4P1k/npp4p/4NRpN/8/1B4QP/P1P3PK/q2r4',
        comment: 'Black gets up hist last resources and threatens mate.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 72,
        moveFrom: 'h5',
        moveTo: 'f6',
        fen: '5r2/p4P1k/npp2N1p/4NRp1/8/1B4QP/P1P3PK/q2r4',
        comment:
          'Just trying to get quickly closer to the 40 moves boundary with a forcing move...',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 73,
        moveFrom: 'h7',
        moveTo: 'h8',
        fen: '5r1k/p4P2/npp2N1p/4NRp1/8/1B4QP/P1P3PK/q2r4',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 74,
        moveFrom: 'g3',
        moveTo: 'f2',
        fen: '5r1k/p4P2/npp2N1p/4NRp1/8/1B5P/P1P2QPK/q2r4',
        comment:
          'The good-looking fork Ng6+ would indeed lose a piece: ...Kg7 and after White notices that the mating thread is still present and opens up space for the king, Black eats the knight ...Kxg6',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 75,
        moveFrom: 'd1',
        moveTo: 'h1',
        fen: '5r1k/p4P2/npp2N1p/4NRp1/8/1B5P/P1P2QPK/q6r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 76,
        moveFrom: 'h2',
        moveTo: 'g3',
        fen: '5r1k/p4P2/npp2N1p/4NRp1/8/1B4KP/P1P2QP1/q6r',
        comment: 'Phew, only one move left and the time pressure is over, finally.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 77,
        moveFrom: 'a1',
        moveTo: 'c3',
        fen: '5r1k/p4P2/npp2N1p/4NRp1/8/1Bq3KP/P1P2QP1/7r',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 78,
        moveFrom: 'e5',
        moveTo: 'd3',
        fen: '5r1k/p4P2/npp2N1p/5Rp1/8/1BqN2KP/P1P2QP1/7r',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 79,
        moveFrom: 'h1',
        moveTo: 'd1',
        fen: '5r1k/p4P2/npp2N1p/5Rp1/8/1BqN2KP/P1P2QP1/3r4',
        comment: 'Setting up a small trap.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 80,
        moveFrom: 'f6',
        moveTo: 'e4',
        fen: '5r1k/p4P2/npp4p/5Rp1/4N3/1BqN2KP/P1P2QP1/3r4',
        comment:
          'if Nd7, then ...Rxd3+ cxd3, Qxd3+ following Qxd7 gets two pieces and a pawn for a rook (though still not bad for White I guess, positionally speaking)',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 81,
        moveFrom: 'c3',
        moveTo: 'g7',
        fen: '5r1k/p4Pq1/npp4p/5Rp1/4N3/1B1N2KP/P1P2QP1/3r4',
        comment:
          "I wasn't sure how to continue now to convert this obviously promising position into a quick win. Attacking the rook and repositioning the queen for a possible Qg4/Qh5 couldn't hurt.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 82,
        moveFrom: 'f2',
        moveTo: 'f3',
        fen: '5r1k/p4Pq1/npp4p/5Rp1/4N3/1B1N1QKP/P1P3P1/3r4',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 83,
        moveFrom: 'd1',
        moveTo: 'h1',
        fen: '5r1k/p4Pq1/npp4p/5Rp1/4N3/1B1N1QKP/P1P3P1/7r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 84,
        moveFrom: 'f5',
        moveTo: 'f6',
        fen: '5r1k/p4Pq1/npp2R1p/6p1/4N3/1B1N1QKP/P1P3P1/7r',
        comment:
          'With the idea of following with Qh5 and hitting on h6. Another plan that came to my mind was getting the rook on e8 with Re5, however this can be easily prevented by Black with Nc7.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 85,
        moveFrom: 'a6',
        moveTo: 'c5',
        fen: '5r1k/p4Pq1/1pp2R1p/2n3p1/4N3/1B1N1QKP/P1P3P1/7r',
        comment: '(?) Black exchanges this defending piece and loses a pawn.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 86,
        moveFrom: 'd3',
        moveTo: 'c5',
        fen: '5r1k/p4Pq1/1pp2R1p/2N3p1/4N3/1B3QKP/P1P3P1/7r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 87,
        moveFrom: 'b6',
        moveTo: 'c5',
        fen: '5r1k/p4Pq1/2p2R1p/2p3p1/4N3/1B3QKP/P1P3P1/7r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 88,
        moveFrom: 'e4',
        moveTo: 'c5',
        fen: '5r1k/p4Pq1/2p2R1p/2N3p1/8/1B3QKP/P1P3P1/7r',
        comment: 'This knight now has two winning places to go: e6 and d7.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 89,
        moveFrom: 'g5',
        moveTo: 'g4',
        fen: '5r1k/p4Pq1/2p2R1p/2N5/6p1/1B3QKP/P1P3P1/7r',
        comment:
          "!? Another move which I wasn't prepared of, attacking my queen. Looks like it has to move away and Black then has a discovered check ...gxh3+, but again, like before in move 34, the rook doesn't need defence, as the queen-sac-and-rebirth trick is still going on on g7. So I can offer to exchange queens.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 90,
        moveFrom: 'f3',
        moveTo: 'g4',
        fen: '5r1k/p4Pq1/2p2R1p/2N5/6Q1/1B4KP/P1P3P1/7r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 91,
        moveFrom: 'g7',
        moveTo: 'g4',
        fen: '5r1k/p4P2/2p2R1p/2N5/6q1/1B4KP/P1P3P1/7r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 92,
        moveFrom: 'g3',
        moveTo: 'g4',
        fen: '5r1k/p4P2/2p2R1p/2N5/6K1/1B5P/P1P3P1/7r',
        comment:
          "Having this clear advantage in material (2 pawns and 2 pieces for a rook), plus a passed pawn on the 7th rank which can't be eliminated without further loss of material, Whites win is ensured.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 93,
        moveFrom: 'h8',
        moveTo: 'g7',
        fen: '5r2/p4Pk1/2p2R1p/2N5/6K1/1B5P/P1P3P1/7r',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 94,
        moveFrom: 'f6',
        moveTo: 'c6',
        fen: '5r2/p4Pk1/2R4p/2N5/6K1/1B5P/P1P3P1/7r',
        comment: 'And Black resigned.',
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 8,
    name: 'First time on GameKnot',
    accuracyPercentage: 0.8,
    recallPercentage: 1,
    precisionPercentage: 0.2,
    plays: [
      {
        id: 0,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: 'QG opening.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'd7',
        moveTo: 'd5',
        fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 2,
        moveFrom: 'c2',
        moveTo: 'c4',
        fen: 'rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'd5',
        moveTo: 'c4',
        fen: 'rnbqkbnr/ppp1pppp/8/8/2pP4/8/PP2PPPP/RNBQKBNR',
        comment: "Queen's gambit accepted!  Actually not used to this...",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 4,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR',
        comment:
          'Assert centre control, the point of the gambit...    In response to comments by sarasani and sicilianunleash, it is true that I was not particularly concerned about 3... b5.  In that case, I would have responded 4. a4 c6 5.b3 (not 5. axb5), or possibly 4.a4 a6? 5.axb5, if I got the chance.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'd8',
        moveTo: 'd6',
        fen: 'rnb1kbnr/ppp1pppp/3q4/8/2pPP3/8/PP3PPP/RNBQKBNR',
        comment: 'Qd6?  Why move the Queen out?  Becomes a potential target.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnb1kbnr/ppp1pppp/3q4/8/2BPP3/8/PP3PPP/RNBQK1NR',
        comment: 'Recapture the pawn, assert stronger centre control',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'd6',
        moveTo: 'b4',
        fen: 'rnb1kbnr/ppp1pppp/8/8/1qBPP3/8/PP3PPP/RNBQK1NR',
        comment:
          'Qb4 ?  Why?  Attempting to grab the bishop?  Easily defended.  And from here, I can start developing with tempo.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'b1',
        moveTo: 'd2',
        fen: 'rnb1kbnr/ppp1pppp/8/8/1qBPP3/8/PP1N1PPP/R1BQK1NR',
        comment: 'Defensive, but the Queen is vulnerable.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 9,
        moveFrom: 'b8',
        moveTo: 'c6',
        fen: 'r1b1kbnr/ppp1pppp/2n5/8/1qBPP3/8/PP1N1PPP/R1BQK1NR',
        comment:
          'Not bad.  Attempt to regain centre control since the pawn is not protected by the Queen anymore.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 10,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'r1b1kbnr/ppp1pppp/2n5/8/1qBPP3/5N2/PP1N1PPP/R1BQK2R',
        comment: 'But again, easily defended.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'g7',
        moveTo: 'g6',
        fen: 'r1b1kbnr/ppp1pp1p/2n3p1/8/1qBPP3/5N2/PP1N1PPP/R1BQK2R',
        comment: 'Setting up the fianchetto, with idea to move ...Bg7.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'a2',
        moveTo: 'a3',
        fen: 'r1b1kbnr/ppp1pp1p/2n3p1/8/1qBPP3/P4N2/1P1N1PPP/R1BQK2R',
        comment: 'So let me get the Queen out of here, and develop my pieces',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'b4',
        moveTo: 'a5',
        fen: 'r1b1kbnr/ppp1pp1p/2n3p1/q7/2BPP3/P4N2/1P1N1PPP/R1BQK2R',
        comment:
          'Backs up the Queen.  I do not want to move b4, since 8.b4 Nxb4 loses a pawn, or worse, for me.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'r1b1kbnr/ppp1pp1p/2n3p1/q7/2BPP3/P4N2/1P1N1PPP/R1BQ1RK1',
        comment: 'Castle my King to get rid of that annoying pin.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'r1b1kb1r/ppp1pp1p/2n2np1/q7/2BPP3/P4N2/1P1N1PPP/R1BQ1RK1',
        comment:
          'Not sure why this play.  Blocks in Bg7, also the Knight on d2 is no longer pinned.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 16,
        moveFrom: 'd2',
        moveTo: 'b3',
        fen: 'r1b1kb1r/ppp1pp1p/2n2np1/q7/2BPP3/PN3N2/1P3PPP/R1BQ1RK1',
        comment: 'As seen here.  Of course, this exposes my pawn on e4, which I regretted later.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'a5',
        moveTo: 'h5',
        fen: 'r1b1kb1r/ppp1pp1p/2n2np1/7q/2BPP3/PN3N2/1P3PPP/R1BQ1RK1',
        comment:
          'Moves Queen to Kingside, which is where my King is now.  Also, Queen is less exposed to my pieces, which for the moment, are all Queenside.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'c1',
        moveTo: 'f4',
        fen: 'r1b1kb1r/ppp1pp1p/2n2np1/7q/2BPPB2/PN3N2/1P3PPP/R2Q1RK1',
        comment:
          'Desiring here to gain dominant centre control.  However, overlooked vulnerable pawn on e4.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'f6',
        moveTo: 'e4',
        fen: 'r1b1kb1r/ppp1pp1p/2n3p1/7q/2BPnB2/PN3N2/1P3PPP/R2Q1RK1',
        comment:
          "Takes the pawn.  Overall though, I have slightly better centre control, and black's queen is still exposed.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'd1',
        moveTo: 'e2',
        fen: 'r1b1kb1r/ppp1pp1p/2n3p1/7q/2BPnB2/PN3N2/1P2QPPP/R4RK1',
        comment: 'Attack the Knight.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'f7',
        moveTo: 'f5',
        fen: 'r1b1kb1r/ppp1p2p/2n3p1/5p1q/2BPnB2/PN3N2/1P2QPPP/R4RK1',
        comment:
          'Why?  The Queen is limited in space she can go, and is not really a threat here.  Why not Bf4, developing a more mobile piece, and freeing up the rook on a8, to move to half-open d file.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 22,
        moveFrom: 'a1',
        moveTo: 'd1',
        fen: 'r1b1kb1r/ppp1p2p/2n3p1/5p1q/2BPnB2/PN3N2/1P2QPPP/3R1RK1',
        comment: 'Take advantage of space to move to half-open file.  Coming down the centre.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'h7',
        moveTo: 'h6',
        fen: 'r1b1kb1r/ppp1p3/2n3pp/5p1q/2BPnB2/PN3N2/1P2QPPP/3R1RK1',
        comment: '?  Not sure why.  Presumably to stop Bg5.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'f4',
        moveTo: 'e5',
        fen: 'r1b1kb1r/ppp1p3/2n3pp/4Bp1q/2BPn3/PN3N2/1P2QPPP/3R1RK1',
        comment:
          "But I wasn't going there.  Now castling become harder.  Also, by tempting the Knight away, the d file becomes open, so my Rook on d1 is now worth more.  Still, right here, my dark bishop is currently worth more than his Knight on c6, so this isn't a bad play, really.  Besides, my bishop is obviously threatening his rook, and his options are either give up right to castle, or kill the bishop.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'c6',
        moveTo: 'e5',
        fen: 'r1b1kb1r/ppp1p3/6pp/4np1q/2BPn3/PN3N2/1P2QPPP/3R1RK1',
        comment: 'Now, when I take with dxe5, my rook has access through all of d-file.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'd4',
        moveTo: 'e5',
        fen: 'r1b1kb1r/ppp1p3/6pp/4Pp1q/2B1n3/PN3N2/1P2QPPP/3R1RK1',
        comment: 'Like so.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'e7',
        moveTo: 'e6',
        fen: 'r1b1kb1r/ppp5/4p1pp/4Pp1q/2B1n3/PN3N2/1P2QPPP/3R1RK1',
        comment:
          "Good job.  Blocks in my pawn, prevents my white bishop from offering a threat in case black wants to castle.  However, further blocks in black's white bishop.  From here on, black is on the defensive.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 28,
        moveFrom: 'e2',
        moveTo: 'd3',
        fen: 'r1b1kb1r/ppp5/4p1pp/4Pp1q/2B1n3/PN1Q1N2/1P3PPP/3R1RK1',
        comment:
          'Threatening Qd8 , which would have actually been a bad idea.  After 16. Qd8   Kf7, my Queen would have had few places to go.  Still, this would pin his bishops, potentially.  Note that 16. Qd8   Kf7, 17.Qf6  would lead to disaster for me.  Anyway, getting my forces ready for a move down the centre.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'f8',
        moveTo: 'e7',
        fen: 'r1b1k2r/ppp1b3/4p1pp/4Pp1q/2B1n3/PN1Q1N2/1P3PPP/3R1RK1',
        comment:
          "Not bad defensive move.  Now, I can't do Qd8 .  I have to get rid of one of these bishops, is what I'm thinking here.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'b3',
        moveTo: 'd4',
        fen: 'r1b1k2r/ppp1b3/4p1pp/4Pp1q/2BNn3/P2Q1N2/1P3PPP/3R1RK1',
        comment:
          "Here I was thinking of 17. Nd4xe6, with an idea to lure out the white bishop, or possibly 17.Bxe6 to force the white bishop out.  This wouldn't have been too bad, as 17.Bxe6 Bxe6 18.Nx36 would have allowed me to move Qd7 , barricading in the King.  Wonder what would have happened if I did that?",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 31,
        moveFrom: 'b7',
        moveTo: 'b6',
        fen: 'r1b1k2r/p1p1b3/1p2p1pp/4Pp1q/2BNn3/P2Q1N2/1P3PPP/3R1RK1',
        comment:
          'But now this allows me to threaten the black bishop.  I would prefer to move my Queen to the back rank directly anyway.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'd4',
        moveTo: 'c6',
        fen: 'r1b1k2r/p1p1b3/1pN1p1pp/4Pp1q/2B1n3/P2Q1N2/1P3PPP/3R1RK1',
        comment: "Eyes on black's dark bishop.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'e4',
        moveTo: 'd6',
        fen: 'r1b1k2r/p1p1b3/1pNnp1pp/4Pp1q/2B5/P2Q1N2/1P3PPP/3R1RK1',
        comment:
          'Threatens my bishop here, but more importantly, blocks my access to the d-file.  I definitely do not want to take the Knight here, since 18.exd6 cxd6 means this file is pretty much closed to me.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 34,
        moveFrom: 'c6',
        moveTo: 'e7',
        fen: 'r1b1k2r/p1p1N3/1p1np1pp/4Pp1q/2B5/P2Q1N2/1P3PPP/3R1RK1',
        comment: 'Death to the black bishop!',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'd6',
        moveTo: 'c4',
        fen: 'r1b1k2r/p1p1N3/1p2p1pp/4Pp1q/2n5/P2Q1N2/1P3PPP/3R1RK1',
        comment: 'At this point, who cares about the white bishop? The file is open, so I take it.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 36,
        moveFrom: 'd3',
        moveTo: 'd8',
        fen: 'r1bQk2r/p1p1N3/1p2p1pp/4Pp1q/2n5/P4N2/1P3PPP/3R1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 37,
        moveFrom: 'e8',
        moveTo: 'f7',
        fen: 'r1bQ3r/p1p1Nk2/1p2p1pp/4Pp1q/2n5/P4N2/1P3PPP/3R1RK1',
        comment: 'Only place to move, I have to do something about that rook.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 38,
        moveFrom: 'd8',
        moveTo: 'h8',
        fen: 'r1b4Q/p1p1Nk2/1p2p1pp/4Pp1q/2n5/P4N2/1P3PPP/3R1RK1',
        comment: 'Gotta do it.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'f7',
        moveTo: 'e7',
        fen: 'r1b4Q/p1p1k3/1p2p1pp/4Pp1q/2n5/P4N2/1P3PPP/3R1RK1',
        comment:
          'White bishop is still pinned, the King has minimal access here.  My King is nice and safe, and the black Queen is still stuck.  Goodbye Knight, you served me well.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'h8',
        moveTo: 'f6',
        fen: 'r1b5/p1p1k3/1p2pQpp/4Pp1q/2n5/P4N2/1P3PPP/3R1RK1',
        comment:
          'Best play at the moment.  Conversely, I suppose I could have done Qd8 , but that would have led to repetition.  This way, the King is barricaded in.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'e7',
        moveTo: 'e8',
        fen: 'r1b1k3/p1p5/1p2pQpp/4Pp1q/2n5/P4N2/1P3PPP/3R1RK1',
        comment: "And it's all over from here.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'd1',
        moveTo: 'd8',
        fen: 'r1bRk3/p1p5/1p2pQpp/4Pp1q/2n5/P4N2/1P3PPP/5RK1',
        comment: 'Really enjoyed this game.',
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 9,
    name: 'Team match',
    accuracyPercentage: 0.7,
    recallPercentage: 1,
    precisionPercentage: 0.4375,
    plays: [
      {
        id: 0,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'e2',
        moveTo: 'e3',
        fen: 'rnbqkb1r/pppppppp/5n2/8/3P4/4P3/PPP2PPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 3,
        moveFrom: 'g7',
        moveTo: 'g6',
        fen: 'rnbqkb1r/pppppp1p/5np1/8/3P4/4P3/PPP2PPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'f1',
        moveTo: 'd3',
        fen: 'rnbqkb1r/pppppp1p/5np1/8/3P4/3BP3/PPP2PPP/RNBQK1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'f8',
        moveTo: 'g7',
        fen: 'rnbqk2r/ppppppbp/5np1/8/3P4/3BP3/PPP2PPP/RNBQK1NR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'f2',
        moveTo: 'f4',
        fen: 'rnbqk2r/ppppppbp/5np1/8/3P1P2/3BP3/PPP3PP/RNBQK1NR',
        comment:
          "Never seen this before. I'm not sure if this is good or unwise for white (would have made more sense for e3 to be on e4 I think), but it does increase kingside pressure.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'rnbq1rk1/ppppppbp/5np1/8/3P1P2/3BP3/PPP3PP/RNBQK1NR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbq1rk1/ppppppbp/5np1/8/3P1P2/3BPN2/PPP3PP/RNBQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'd7',
        moveTo: 'd5',
        fen: 'rnbq1rk1/ppp1ppbp/5np1/3p4/3P1P2/3BPN2/PPP3PP/RNBQK2R',
        comment: 'Holding the e4 square for the time being.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'b1',
        moveTo: 'd2',
        fen: 'rnbq1rk1/ppp1ppbp/5np1/3p4/3P1P2/3BPN2/PPPN2PP/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'b7',
        moveTo: 'b6',
        fen: 'rnbq1rk1/p1p1ppbp/1p3np1/3p4/3P1P2/3BPN2/PPPN2PP/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'rnbq1rk1/p1p1ppbp/1p3np1/3p4/3P1P2/3BPN2/PPPN2PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 13,
        moveFrom: 'c7',
        moveTo: 'c5',
        fen: 'rnbq1rk1/p3ppbp/1p3np1/2pp4/3P1P2/3BPN2/PPPN2PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'c2',
        moveTo: 'c3',
        fen: 'rnbq1rk1/p3ppbp/1p3np1/2pp4/3P1P2/2PBPN2/PP1N2PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 15,
        moveFrom: 'b8',
        moveTo: 'd7',
        fen: 'r1bq1rk1/p2nppbp/1p3np1/2pp4/3P1P2/2PBPN2/PP1N2PP/R1BQ1RK1',
        comment:
          "I'm really not sure about this move. I think Nc6 would have been better (doesn't block in the bishop), but as I wanted my bishop on b7 if I could manage to clear the diagonal, I didn't want to block it in for the future. Shouldn't be making plans whilst the position is like this though :S",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 16,
        moveFrom: 'f3',
        moveTo: 'e5',
        fen: 'r1bq1rk1/p2nppbp/1p3np1/2ppN3/3P1P2/2PBP3/PP1N2PP/R1BQ1RK1',
        comment:
          'I really want to relieve kingside pressure now, especially in light of possible pawn advances.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'd7',
        moveTo: 'e5',
        fen: 'r1bq1rk1/p3ppbp/1p3np1/2ppn3/3P1P2/2PBP3/PP1N2PP/R1BQ1RK1',
        comment:
          'The knight exchange is not really because the exchange was beneficial in itself, so much as freeing up my bishop again.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 18,
        moveFrom: 'f4',
        moveTo: 'e5',
        fen: 'r1bq1rk1/p3ppbp/1p3np1/2ppP3/3P4/2PBP3/PP1N2PP/R1BQ1RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 19,
        moveFrom: 'f6',
        moveTo: 'd7',
        fen: 'r1bq1rk1/p2nppbp/1p4p1/2ppP3/3P4/2PBP3/PP1N2PP/R1BQ1RK1',
        comment:
          "But having been forced back here, it really hasn't achieved much :-(  White has a clear initiative and pressure advantage now, and black is definitely on the back foot.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 20,
        moveFrom: 'd2',
        moveTo: 'f3',
        fen: 'r1bq1rk1/p2nppbp/1p4p1/2ppP3/3P4/2PBPN2/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'f7',
        moveTo: 'f5',
        fen: 'r1bq1rk1/p2np1bp/1p4p1/2ppPp2/3P4/2PBPN2/PP4PP/R1BQ1RK1',
        comment:
          'Either to lock the kingside or get counter play if an en-passant capture is played.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'e5',
        moveTo: 'f6',
        fen: 'r1bq1rk1/p2np1bp/1p3Pp1/2pp4/3P4/2PBPN2/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'e7',
        moveTo: 'f6',
        fen: 'r1bq1rk1/p2n2bp/1p3pp1/2pp4/3P4/2PBPN2/PP4PP/R1BQ1RK1',
        comment:
          "I chose this as I think Rxf6 would leave the rook vulnerable to too many minor piece and pawn combinations, and it doesn't have much useful manoeuvrability  at this stage. The bishop was definitely an option, but I wanted the ability to attack the e3 pawn in the long run, so I chose to go with opening up the e file instead.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'e3',
        moveTo: 'e4',
        fen: 'r1bq1rk1/p2n2bp/1p3pp1/2pp4/3PP3/2PB1N2/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'c8',
        moveTo: 'b7',
        fen: 'r2q1rk1/pb1n2bp/1p3pp1/2pp4/3PP3/2PB1N2/PP4PP/R1BQ1RK1',
        comment: 'Now my bishop can prove useful on this diagonal.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'e4',
        moveTo: 'd5',
        fen: 'r2q1rk1/pb1n2bp/1p3pp1/2pP4/3P4/2PB1N2/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'b7',
        moveTo: 'd5',
        fen: 'r2q1rk1/p2n2bp/1p3pp1/2pb4/3P4/2PB1N2/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'f3',
        moveTo: 'h4',
        fen: 'r2q1rk1/p2n2bp/1p3pp1/2pb4/3P3N/2PB4/PP4PP/R1BQ1RK1',
        comment:
          'Can only be preparing 16. Nxg6 hxg6 17. Bxg6. Torn now between f5 to protect the capture and attack the knight with my queen, or starting a counter-offensive of my own.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'c5',
        moveTo: 'd4',
        fen: 'r2q1rk1/p2n2bp/1p3pp1/3b4/3p3N/2PB4/PP4PP/R1BQ1RK1',
        comment:
          'Opted for the counter-offensive, if cxd4 then f5 becomes quite strong as it attacks both the knight and the d4 pawn (which would also result in a useful check ...)',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 30,
        moveFrom: 'h4',
        moveTo: 'g6',
        fen: 'r2q1rk1/p2n2bp/1p3pN1/3b4/3p4/2PB4/PP4PP/R1BQ1RK1',
        comment: "Ah, white ignored it - I hadn't considered this.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'h7',
        moveTo: 'g6',
        fen: 'r2q1rk1/p2n2b1/1p3pp1/3b4/3p4/2PB4/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'd3',
        moveTo: 'g6',
        fen: 'r2q1rk1/p2n2b1/1p3pB1/3b4/3p4/2P5/PP4PP/R1BQ1RK1',
        comment:
          "Material advantage, but horribly exposed king. I need activation and counter-play as soon as I can get it. I'm looking at a threatened Qh5, so attacking the bishop would be useful.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'd7',
        moveTo: 'e5',
        fen: 'r2q1rk1/p5b1/1p3pB1/3bn3/3p4/2P5/PP4PP/R1BQ1RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 34,
        moveFrom: 'g6',
        moveTo: 'c2',
        fen: 'r2q1rk1/p5b1/1p3p2/3bn3/3p4/2P5/PPB3PP/R1BQ1RK1',
        comment:
          "Retreating the bishop -- wow, this game is sharp. Looking at Bxg2 to return material, and after Kxg2 Qd5  I get more possibilities for counter-play. Of course, I'd rather keep the material advantage.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 35,
        moveFrom: 'd4',
        moveTo: 'c3',
        fen: 'r2q1rk1/p5b1/1p3p2/3bn3/8/2p5/PPB3PP/R1BQ1RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 36,
        moveFrom: 'd1',
        moveTo: 'h5',
        fen: 'r2q1rk1/p5b1/1p3p2/3bn2Q/8/2p5/PPB3PP/R1B2RK1',
        comment:
          "Hmmm, seems to be threatening Bh7 , hard to see how to refute it. I'd like to get my Queen into the defence, so I'm going to go with Qe8 on the offchance of a Queen exchange.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 37,
        moveFrom: 'd8',
        moveTo: 'e8',
        fen: 'r3qrk1/p5b1/1p3p2/3bn2Q/8/2p5/PPB3PP/R1B2RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 38,
        moveFrom: 'h5',
        moveTo: 'h7',
        fen: 'r3qrk1/p5bQ/1p3p2/3bn3/8/2p5/PPB3PP/R1B2RK1',
        comment: 'Ah, how obvious. Now there are a lot of weaknesses in my position.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'g8',
        moveTo: 'f7',
        fen: 'r3qr2/p4kbQ/1p3p2/3bn3/8/2p5/PPB3PP/R1B2RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'c1',
        moveTo: 'g5',
        fen: 'r3qr2/p4kbQ/1p3p2/3bn1B1/8/2p5/PPB3PP/R4RK1',
        comment:
          'Obvious, and rather cute -- It is vital to keep the knight on e5, yet if I move to the e file it can be skewered by a rook. This is horrible.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'f7',
        moveTo: 'e6',
        fen: 'r3qr2/p5bQ/1p2kp2/3bn1B1/8/2p5/PPB3PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'c2',
        moveTo: 'f5',
        fen: 'r3qr2/p5bQ/1p2kp2/3bnBB1/8/2p5/PP4PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 43,
        moveFrom: 'e6',
        moveTo: 'd6',
        fen: 'r3qr2/p5bQ/1p1k1p2/3bnBB1/8/2p5/PP4PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'h7',
        moveTo: 'g7',
        fen: 'r3qr2/p5Q1/1p1k1p2/3bnBB1/8/2p5/PP4PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'f6',
        moveTo: 'g5',
        fen: 'r3qr2/p5Q1/1p1k4/3bnBp1/8/2p5/PP4PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 46,
        moveFrom: 'b2',
        moveTo: 'c3',
        fen: 'r3qr2/p5Q1/1p1k4/3bnBp1/8/2P5/P5PP/R4RK1',
        comment: 'Material advantage is still mine, but the position is just horrible.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 47,
        moveFrom: 'e8',
        moveTo: 'e7',
        fen: 'r4r2/p3q1Q1/1p1k4/3bnBp1/8/2P5/P5PP/R4RK1',
        comment: 'Again hoping for a queen exchange, but why oh why did I not play Rf7.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 48,
        moveFrom: 'g7',
        moveTo: 'h6',
        fen: 'r4r2/p3q3/1p1k3Q/3bnBp1/8/2P5/P5PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 49,
        moveFrom: 'e7',
        moveTo: 'f6',
        fen: 'r4r2/p7/1p1k1q1Q/3bnBp1/8/2P5/P5PP/R4RK1',
        comment: 'Chose against Rf6 here because of the loss of the pawn.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 50,
        moveFrom: 'h6',
        moveTo: 'h7',
        fen: 'r4r2/p6Q/1p1k1q2/3bnBp1/8/2P5/P5PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 51,
        moveFrom: 'f8',
        moveTo: 'f7',
        fen: 'r7/p4r1Q/1p1k1q2/3bnBp1/8/2P5/P5PP/R4RK1',
        comment: 'Now white seems to have lost momentum, and I can try to get the king to safety.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'h7',
        moveTo: 'h3',
        fen: 'r7/p4r2/1p1k1q2/3bnBp1/8/2P4Q/P5PP/R4RK1',
        comment:
          "I really need to get to get the queen of the f file whilst the white rook is on f1, but my King needs getting to safety first. I cannot travel to f8 with my rook on a8, and I need to avoid all the white squares. Kc7 is possible, but I'd rather activate my a8 rook and maintain initiative.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 53,
        moveFrom: 'a8',
        moveTo: 'h8',
        fen: '7r/p4r2/1p1k1q2/3bnBp1/8/2P4Q/P5PP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 54,
        moveFrom: 'h3',
        moveTo: 'g3',
        fen: '7r/p4r2/1p1k1q2/3bnBp1/8/2P3Q1/P5PP/R4RK1',
        comment:
          'Ah, this is foolish. Now Ke6 and Kc7 are caused problems by Rfe1 or Rae1. Having the knight skewered is awkward to say the least. Ke7 would have been better than 27... Rh8 by a long shot --',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 55,
        moveFrom: 'h8',
        moveTo: 'e8',
        fen: '4r3/p4r2/1p1k1q2/3bnBp1/8/2P3Q1/P5PP/R4RK1',
        comment:
          "What a waste of tempo, and I cannot retreat to e7 without losing the rook's protection of the knight.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'a1',
        moveTo: 'd1',
        fen: '4r3/p4r2/1p1k1q2/3bnBp1/8/2P3Q1/P5PP/3R1RK1',
        comment: 'Oh dear, everything has fallen apart again. Now c4 will simply lose the bishop.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'f7',
        moveTo: 'e7',
        fen: '4r3/p3r3/1p1k1q2/3bnBp1/8/2P3Q1/P5PP/3R1RK1',
        comment: 'Trying for Qf7, but playing with fire, the game is lost now.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'f5',
        moveTo: 'e4',
        fen: '4r3/p3r3/1p1k1q2/3bn1p1/4B3/2P3Q1/P5PP/3R1RK1',
        comment:
          'Hmmm... with the discovered attack on the queen this is probably even better than c4. Tempted to play Qe6 and take the bishop queen for bishop rook, but it is likely to be losing. I have one last tactical attempt to try.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'f6',
        moveTo: 'f1',
        fen: '4r3/p3r3/1p1k4/3bn1p1/4B3/2P3Q1/P5PP/3R1qK1',
        comment: 'Hoping he takes with the rook.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 60,
        moveFrom: 'g1',
        moveTo: 'f1',
        fen: '4r3/p3r3/1p1k4/3bn1p1/4B3/2P3Q1/P5PP/3R1K2',
        comment: 'The final nail.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'e8',
        moveTo: 'f8',
        fen: '5r2/p3r3/1p1k4/3bn1p1/4B3/2P3Q1/P5PP/3R1K2',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'f1',
        moveTo: 'g1',
        fen: '5r2/p3r3/1p1k4/3bn1p1/4B3/2P3Q1/P5PP/3R2K1',
        comment: 'Well finished, nothing for black to do now.  Game annotation for team benefit --',
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 10,
    name: 'Queens Gambit',
    accuracyPercentage: 0.7142857142857143,
    recallPercentage: 0.5,
    precisionPercentage: 0.5,
    plays: [
      {
        id: 0,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'd7',
        moveTo: 'd5',
        fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 2,
        moveFrom: 'c2',
        moveTo: 'c4',
        fen: 'rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 3,
        moveFrom: 'e7',
        moveTo: 'e6',
        fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 4,
        moveFrom: 'a2',
        moveTo: 'a3',
        fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/P7/1P2PPPP/RNBQKBNR',
        comment: "I do not know much of Queen's gambit, but I didn't understood this move.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/P7/1P2PPPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 6,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/P1N5/1P2PPPP/R1BQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 7,
        moveFrom: 'f8',
        moveTo: 'd6',
        fen: 'rnbqk2r/ppp2ppp/3bpn2/3p4/2PP4/P1N5/1P2PPPP/R1BQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 8,
        moveFrom: 'e2',
        moveTo: 'e3',
        fen: 'rnbqk2r/ppp2ppp/3bpn2/3p4/2PP4/P1N1P3/1P3PPP/R1BQKBNR',
        comment: 'Both are simply developing their peices.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 9,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: 'rnbq1rk1/ppp2ppp/3bpn2/3p4/2PP4/P1N1P3/1P3PPP/R1BQKBNR',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbq1rk1/ppp2ppp/3bpn2/3p4/2PP4/P1N1PN2/1P3PPP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'f8',
        moveTo: 'e8',
        fen: 'rnbqr1k1/ppp2ppp/3bpn2/3p4/2PP4/P1N1PN2/1P3PPP/R1BQKB1R',
        comment:
          'This rook will help in moving the e pawn tio e5. Later or sooner the center is going to open, so this rook should help.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 12,
        moveFrom: 'f3',
        moveTo: 'e5',
        fen: 'rnbqr1k1/ppp2ppp/3bpn2/3pN3/2PP4/P1N1P3/1P3PPP/R1BQKB1R',
        comment:
          'A nice move. Taking it immediately would not help as I would be exchanging my active bishop for his knight and the pawn at e5 would be very powerful after white moves f4.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 13,
        moveFrom: 'b8',
        moveTo: 'd7',
        fen: 'r1bqr1k1/pppn1ppp/3bpn2/3pN3/2PP4/P1N1P3/1P3PPP/R1BQKB1R',
        comment:
          'An attempt to seige the center. The knight will either go back in which case I can break open the center with c5 or c6 then e5, or the f4 pawn will come ahead.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 14,
        moveFrom: 'f2',
        moveTo: 'f4',
        fen: 'r1bqr1k1/pppn1ppp/3bpn2/3pN3/2PP1P2/P1N1P3/1P4PP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 15,
        moveFrom: 'f6',
        moveTo: 'e4',
        fen: 'r1bqr1k1/pppn1ppp/3bp3/3pN3/2PPnP2/P1N1P3/1P4PP/R1BQKB1R',
        comment:
          'I am taking the space left behind by the white, and also f6 can come to push back the knight at e5',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 16,
        moveFrom: 'c3',
        moveTo: 'e4',
        fen: 'r1bqr1k1/pppn1ppp/3bp3/3pN3/2PPNP2/P3P3/1P4PP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'd5',
        moveTo: 'e4',
        fen: 'r1bqr1k1/pppn1ppp/3bp3/4N3/2PPpP2/P3P3/1P4PP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'f1',
        moveTo: 'e2',
        fen: 'r1bqr1k1/pppn1ppp/3bp3/4N3/2PPpP2/P3P3/1P2B1PP/R1BQK2R',
        comment: 'White is trying to secure his king by castling.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 19,
        moveFrom: 'd8',
        moveTo: 'h4',
        fen: 'r1b1r1k1/pppn1ppp/3bp3/4N3/2PPpP1q/P3P3/1P2B1PP/R1BQK2R',
        comment: 'Trying to weaken the kingside to form an attack.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 20,
        moveFrom: 'g2',
        moveTo: 'g3',
        fen: 'r1b1r1k1/pppn1ppp/3bp3/4N3/2PPpP1q/P3P1P1/1P2B2P/R1BQK2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'h4',
        moveTo: 'h3',
        fen: 'r1b1r1k1/pppn1ppp/3bp3/4N3/2PPpP2/P3P1Pq/1P2B2P/R1BQK2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'e2',
        moveTo: 'f1',
        fen: 'r1b1r1k1/pppn1ppp/3bp3/4N3/2PPpP2/P3P1Pq/1P5P/R1BQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'h3',
        moveTo: 'h6',
        fen: 'r1b1r1k1/pppn1ppp/3bp2q/4N3/2PPpP2/P3P1P1/1P5P/R1BQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'f1',
        moveTo: 'g2',
        fen: 'r1b1r1k1/pppn1ppp/3bp2q/4N3/2PPpP2/P3P1P1/1P4BP/R1BQK2R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'f7',
        moveTo: 'f6',
        fen: 'r1b1r1k1/pppn2pp/3bpp1q/4N3/2PPpP2/P3P1P1/1P4BP/R1BQK2R',
        comment:
          'Here I sacrificed my pawn i nan attempt to seige the centerand activate my peices.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'e5',
        moveTo: 'd7',
        fen: 'r1b1r1k1/pppN2pp/3bpp1q/8/2PPpP2/P3P1P1/1P4BP/R1BQK2R',
        comment: 'The sacrifice accepted.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'c8',
        moveTo: 'd7',
        fen: 'r3r1k1/pppb2pp/3bpp1q/8/2PPpP2/P3P1P1/1P4BP/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'g2',
        moveTo: 'e4',
        fen: 'r3r1k1/pppb2pp/3bpp1q/8/2PPBP2/P3P1P1/1P5P/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'e6',
        moveTo: 'e5',
        fen: 'r3r1k1/pppb2pp/3b1p1q/4p3/2PPBP2/P3P1P1/1P5P/R1BQK2R',
        comment: 'The center is attacked.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'e4',
        moveTo: 'd5',
        fen: 'r3r1k1/pppb2pp/3b1p1q/3Bp3/2PP1P2/P3P1P1/1P5P/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 31,
        moveFrom: 'g8',
        moveTo: 'h8',
        fen: 'r3r2k/pppb2pp/3b1p1q/3Bp3/2PP1P2/P3P1P1/1P5P/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 32,
        moveFrom: 'f4',
        moveTo: 'e5',
        fen: 'r3r2k/pppb2pp/3b1p1q/3BP3/2PP4/P3P1P1/1P5P/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 33,
        moveFrom: 'f6',
        moveTo: 'e5',
        fen: 'r3r2k/pppb2pp/3b3q/3Bp3/2PP4/P3P1P1/1P5P/R1BQK2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 34,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'r3r2k/pppb2pp/3b3q/3Bp3/2PP4/P3P1P1/1P5P/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 35,
        moveFrom: 'c7',
        moveTo: 'c6',
        fen: 'r3r2k/pp1b2pp/2pb3q/3Bp3/2PP4/P3P1P1/1P5P/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 36,
        moveFrom: 'd5',
        moveTo: 'g2',
        fen: 'r3r2k/pp1b2pp/2pb3q/4p3/2PP4/P3P1P1/1P4BP/R1BQ1RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 37,
        moveFrom: 'e5',
        moveTo: 'e4',
        fen: 'r3r2k/pp1b2pp/2pb3q/8/2PPp3/P3P1P1/1P4BP/R1BQ1RK1',
        comment:
          'Though the pawn at e4 is isolated, but still it is very useful in trapping both bishops. It also creates a partition between the king and the queen side, in which case my bishops are very instrumental in forming an attack.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 38,
        moveFrom: 'd1',
        moveTo: 'c2',
        fen: 'r3r2k/pp1b2pp/2pb3q/8/2PPp3/P3P1P1/1PQ3BP/R1B2RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'h6',
        moveTo: 'g6',
        fen: 'r3r2k/pp1b2pp/2pb2q1/8/2PPp3/P3P1P1/1PQ3BP/R1B2RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'c1',
        moveTo: 'd2',
        fen: 'r3r2k/pp1b2pp/2pb2q1/8/2PPp3/P3P1P1/1PQB2BP/R4RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'c6',
        moveTo: 'c5',
        fen: 'r3r2k/pp1b2pp/3b2q1/2p5/2PPp3/P3P1P1/1PQB2BP/R4RK1',
        comment:
          'Trying to open the Queen side a bit to make my rooks active. Note that right now b5 would not be good as white can simply reply c5, completely lokcing the queen side',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'd4',
        moveTo: 'c5',
        fen: 'r3r2k/pp1b2pp/3b2q1/2P5/2P1p3/P3P1P1/1PQB2BP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 43,
        moveFrom: 'd6',
        moveTo: 'c5',
        fen: 'r3r2k/pp1b2pp/6q1/2b5/2P1p3/P3P1P1/1PQB2BP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 44,
        moveFrom: 'f1',
        moveTo: 'f4',
        fen: 'r3r2k/pp1b2pp/6q1/2b5/2P1pR2/P3P1P1/1PQB2BP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 45,
        moveFrom: 'd7',
        moveTo: 'c6',
        fen: 'r3r2k/pp4pp/2b3q1/2b5/2P1pR2/P3P1P1/1PQB2BP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 46,
        moveFrom: 'b2',
        moveTo: 'b4',
        fen: 'r3r2k/pp4pp/2b3q1/2b5/1PP1pR2/P3P1P1/2QB2BP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 47,
        moveFrom: 'c5',
        moveTo: 'd6',
        fen: 'r3r2k/pp4pp/2bb2q1/8/1PP1pR2/P3P1P1/2QB2BP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 48,
        moveFrom: 'f4',
        moveTo: 'f1',
        fen: 'r3r2k/pp4pp/2bb2q1/8/1PP1p3/P3P1P1/2QB2BP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 49,
        moveFrom: 'a8',
        moveTo: 'c8',
        fen: '2r1r2k/pp4pp/2bb2q1/8/1PP1p3/P3P1P1/2QB2BP/R4RK1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 50,
        moveFrom: 'b4',
        moveTo: 'b5',
        fen: '2r1r2k/pp4pp/2bb2q1/1P6/2P1p3/P3P1P1/2QB2BP/R4RK1',
        comment: 'This was a blunder done.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 51,
        moveFrom: 'c6',
        moveTo: 'b5',
        fen: '2r1r2k/pp4pp/3b2q1/1b6/2P1p3/P3P1P1/2QB2BP/R4RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 52,
        moveFrom: 'f1',
        moveTo: 'b1',
        fen: '2r1r2k/pp4pp/3b2q1/1b6/2P1p3/P3P1P1/2QB2BP/RR4K1',
        comment:
          'Now there was no way to protect the c pawn. So this tries to seige my a7,b7 pawns.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 53,
        moveFrom: 'b5',
        moveTo: 'c4',
        fen: '2r1r2k/pp4pp/3b2q1/8/2b1p3/P3P1P1/2QB2BP/RR4K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 54,
        moveFrom: 'c2',
        moveTo: 'a4',
        fen: '2r1r2k/pp4pp/3b2q1/8/Q1b1p3/P3P1P1/3B2BP/RR4K1',
        comment: 'both of my queen side pawn will now fall apart',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 55,
        moveFrom: 'c4',
        moveTo: 'e2',
        fen: '2r1r2k/pp4pp/3b2q1/8/Q3p3/P3P1P1/3Bb1BP/RR4K1',
        comment:
          'right now there is only a white bishop to defend the king. Every other peice is far away in the Queen side. the wall at e4 and e3 pawn seperates the two parts very effectively.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'b1',
        moveTo: 'b7',
        fen: '2r1r2k/pR4pp/3b2q1/8/Q3p3/P3P1P1/3Bb1BP/R5K1',
        comment: 'taking up my pawns',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'e2',
        moveTo: 'f3',
        fen: '2r1r2k/pR4pp/3b2q1/8/Q3p3/P3PbP1/3B2BP/R5K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 58,
        moveFrom: 'a1',
        moveTo: 'c1',
        fen: '2r1r2k/pR4pp/3b2q1/8/Q3p3/P3PbP1/3B2BP/2R3K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 59,
        moveFrom: 'd6',
        moveTo: 'g3',
        fen: '2r1r2k/pR4pp/6q1/8/Q3p3/P3Pbb1/3B2BP/2R3K1',
        comment:
          'If white replies by 31 gxg3 Qxg3. There is then no way the mate can be prevented.',
        isBestMoment: false,
        isPredictionRight: false,
      },
      {
        id: 60,
        moveFrom: 'g2',
        moveTo: 'f3',
        fen: '2r1r2k/pR4pp/6q1/8/Q3p3/P3PBb1/3B3P/2R3K1',
        comment: 'The only possibility',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'e4',
        moveTo: 'f3',
        fen: '2r1r2k/pR4pp/6q1/8/Q7/P3Ppb1/3B3P/2R3K1',
        comment:
          'Now there is no way mate can be prevented. After 32).... Bxh2  ; 33) Kf1 Qg2  ; 34)Ke1 Qe2  .  So my opponent resigned',
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
  {
    id: 11,
    name: "Let's play chess",
    accuracyPercentage: 0.7894736842105263,
    recallPercentage: 1,
    precisionPercentage: 0.3333333333333333,
    plays: [
      {
        id: 0,
        moveFrom: 'e2',
        moveTo: 'e4',
        fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
        comment:
          "This was a case of what David Bronstein calls 'milking a cow': I obtained a small advantage and then gradually turned the screws until my advantages became overwhelming, culminating in checkmate.",
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 1,
        moveFrom: 'e7',
        moveTo: 'e5',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 2,
        moveFrom: 'g1',
        moveTo: 'f3',
        fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 3,
        moveFrom: 'd8',
        moveTo: 'f6',
        fen: 'rnb1kbnr/pppp1ppp/5q2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
        comment: 'Already, Black is at a positional disadvantage. Way too early to move the Queen.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 4,
        moveFrom: 'b1',
        moveTo: 'c3',
        fen: 'rnb1kbnr/pppp1ppp/5q2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 5,
        moveFrom: 'c7',
        moveTo: 'c6',
        fen: 'rnb1kbnr/pp1p1ppp/2p2q2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 6,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnb1kbnr/pp1p1ppp/2p2q2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R',
        comment: 'Now I have central pressure.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 7,
        moveFrom: 'f8',
        moveTo: 'b4',
        fen: 'rnb1k1nr/pp1p1ppp/2p2q2/4p3/1b1PP3/2N2N2/PPP2PPP/R1BQKB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 8,
        moveFrom: 'd1',
        moveTo: 'd2',
        fen: 'rnb1k1nr/pp1p1ppp/2p2q2/4p3/1b1PP3/2N2N2/PPPQ1PPP/R1B1KB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 9,
        moveFrom: 'e5',
        moveTo: 'd4',
        fen: 'rnb1k1nr/pp1p1ppp/2p2q2/8/1b1pP3/2N2N2/PPPQ1PPP/R1B1KB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 10,
        moveFrom: 'd2',
        moveTo: 'd4',
        fen: 'rnb1k1nr/pp1p1ppp/2p2q2/8/1b1QP3/2N2N2/PPP2PPP/R1B1KB1R',
        comment: 'I will end up with a central advantage and a plus in development.',
        isBestMoment: true,
        isPredictionRight: true,
      },
      {
        id: 11,
        moveFrom: 'b4',
        moveTo: 'c3',
        fen: 'rnb1k1nr/pp1p1ppp/2p2q2/8/3QP3/2b2N2/PPP2PPP/R1B1KB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 12,
        moveFrom: 'b2',
        moveTo: 'c3',
        fen: 'rnb1k1nr/pp1p1ppp/2p2q2/8/3QP3/2P2N2/P1P2PPP/R1B1KB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 13,
        moveFrom: 'f6',
        moveTo: 'd4',
        fen: 'rnb1k1nr/pp1p1ppp/2p5/8/3qP3/2P2N2/P1P2PPP/R1B1KB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 14,
        moveFrom: 'c3',
        moveTo: 'd4',
        fen: 'rnb1k1nr/pp1p1ppp/2p5/8/3PP3/5N2/P1P2PPP/R1B1KB1R',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 15,
        moveFrom: 'd7',
        moveTo: 'd6',
        fen: 'rnb1k1nr/pp3ppp/2pp4/8/3PP3/5N2/P1P2PPP/R1B1KB1R',
        comment:
          "Black's opening has been very weak. All I have to do is begin tightening the screws.",
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 16,
        moveFrom: 'f1',
        moveTo: 'c4',
        fen: 'rnb1k1nr/pp3ppp/2pp4/8/2BPP3/5N2/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 17,
        moveFrom: 'c8',
        moveTo: 'e6',
        fen: 'rn2k1nr/pp3ppp/2ppb3/8/2BPP3/5N2/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 18,
        moveFrom: 'd4',
        moveTo: 'd5',
        fen: 'rn2k1nr/pp3ppp/2ppb3/3P4/2B1P3/5N2/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 19,
        moveFrom: 'c6',
        moveTo: 'd5',
        fen: 'rn2k1nr/pp3ppp/3pb3/3p4/2B1P3/5N2/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 20,
        moveFrom: 'e4',
        moveTo: 'd5',
        fen: 'rn2k1nr/pp3ppp/3pb3/3P4/2B5/5N2/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 21,
        moveFrom: 'e6',
        moveTo: 'f5',
        fen: 'rn2k1nr/pp3ppp/3p4/3P1b2/2B5/5N2/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 22,
        moveFrom: 'f3',
        moveTo: 'd4',
        fen: 'rn2k1nr/pp3ppp/3p4/3P1b2/2BN4/8/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 23,
        moveFrom: 'f5',
        moveTo: 'e4',
        fen: 'rn2k1nr/pp3ppp/3p4/3P4/2BNb3/8/P1P2PPP/R1B1K2R',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 24,
        moveFrom: 'e1',
        moveTo: 'g1',
        fen: 'rn2k1nr/pp3ppp/3p4/3P4/2BNb3/8/P1P2PPP/R1B2RK1',
        comment:
          "My Rook will soon take over the e-file, while Black's development is badly lagging.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 25,
        moveFrom: 'b8',
        moveTo: 'd7',
        fen: 'r3k1nr/pp1n1ppp/3p4/3P4/2BNb3/8/P1P2PPP/R1B2RK1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 26,
        moveFrom: 'f1',
        moveTo: 'e1',
        fen: 'r3k1nr/pp1n1ppp/3p4/3P4/2BNb3/8/P1P2PPP/R1B1R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 27,
        moveFrom: 'g8',
        moveTo: 'f6',
        fen: 'r3k2r/pp1n1ppp/3p1n2/3P4/2BNb3/8/P1P2PPP/R1B1R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 28,
        moveFrom: 'f2',
        moveTo: 'f3',
        fen: 'r3k2r/pp1n1ppp/3p1n2/3P4/2BNb3/5P2/P1P3PP/R1B1R1K1',
        comment:
          "The pin is mightier than the sword. Black has no way to avoid losing the Bishop. If Black had been able to castle more quickly, his Bishop wouldn't have been exposed to the pin.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 29,
        moveFrom: 'a8',
        moveTo: 'c8',
        fen: '2r1k2r/pp1n1ppp/3p1n2/3P4/2BNb3/5P2/P1P3PP/R1B1R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 30,
        moveFrom: 'c4',
        moveTo: 'b5',
        fen: '2r1k2r/pp1n1ppp/3p1n2/1B1P4/3Nb3/5P2/P1P3PP/R1B1R1K1',
        comment: "Now two of Black's pieces are pinned. Resignation wouldn't be a bad choice.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 31,
        moveFrom: 'e8',
        moveTo: 'g8',
        fen: '2r2rk1/pp1n1ppp/3p1n2/1B1P4/3Nb3/5P2/P1P3PP/R1B1R1K1',
        comment: 'Way too late.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 32,
        moveFrom: 'b5',
        moveTo: 'd7',
        fen: '2r2rk1/pp1B1ppp/3p1n2/3P4/3Nb3/5P2/P1P3PP/R1B1R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 33,
        moveFrom: 'f6',
        moveTo: 'd7',
        fen: '2r2rk1/pp1n1ppp/3p4/3P4/3Nb3/5P2/P1P3PP/R1B1R1K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 34,
        moveFrom: 'e1',
        moveTo: 'e4',
        fen: '2r2rk1/pp1n1ppp/3p4/3P4/3NR3/5P2/P1P3PP/R1B3K1',
        comment:
          "Now it's a matter of technique. I'm a piece up in what is essentially already an endgame.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 35,
        moveFrom: 'd7',
        moveTo: 'e5',
        fen: '2r2rk1/pp3ppp/3p4/3Pn3/3NR3/5P2/P1P3PP/R1B3K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 36,
        moveFrom: 'd4',
        moveTo: 'b5',
        fen: '2r2rk1/pp3ppp/3p4/1N1Pn3/4R3/5P2/P1P3PP/R1B3K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 37,
        moveFrom: 'c8',
        moveTo: 'c2',
        fen: '5rk1/pp3ppp/3p4/1N1Pn3/4R3/5P2/P1r3PP/R1B3K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 38,
        moveFrom: 'b5',
        moveTo: 'd6',
        fen: '5rk1/pp3ppp/3N4/3Pn3/4R3/5P2/P1r3PP/R1B3K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 39,
        moveFrom: 'e5',
        moveTo: 'd3',
        fen: '5rk1/pp3ppp/3N4/3P4/4R3/3n1P2/P1r3PP/R1B3K1',
        comment: 'Black must press forward. Passive play = certain defeat.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 40,
        moveFrom: 'c1',
        moveTo: 'f4',
        fen: '5rk1/pp3ppp/3N4/3P4/4RB2/3n1P2/P1r3PP/R5K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 41,
        moveFrom: 'd3',
        moveTo: 'f2',
        fen: '5rk1/pp3ppp/3N4/3P4/4RB2/5P2/P1r2nPP/R5K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 42,
        moveFrom: 'e4',
        moveTo: 'c4',
        fen: '5rk1/pp3ppp/3N4/3P4/2R2B2/5P2/P1r2nPP/R5K1',
        comment: 'Either Black submits to the exchange of Rooks or he loses more material.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 43,
        moveFrom: 'c2',
        moveTo: 'c4',
        fen: '5rk1/pp3ppp/3N4/3P4/2r2B2/5P2/P4nPP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 44,
        moveFrom: 'd6',
        moveTo: 'c4',
        fen: '5rk1/pp3ppp/8/3P4/2N2B2/5P2/P4nPP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 45,
        moveFrom: 'f2',
        moveTo: 'd3',
        fen: '5rk1/pp3ppp/8/3P4/2N2B2/3n1P2/P5PP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 46,
        moveFrom: 'f4',
        moveTo: 'd6',
        fen: '5rk1/pp3ppp/3B4/3P4/2N5/3n1P2/P5PP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 47,
        moveFrom: 'f8',
        moveTo: 'd8',
        fen: '3r2k1/pp3ppp/3B4/3P4/2N5/3n1P2/P5PP/R5K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 48,
        moveFrom: 'a1',
        moveTo: 'd1',
        fen: '3r2k1/pp3ppp/3B4/3P4/2N5/3n1P2/P5PP/3R2K1',
        comment: 'With Black being forced to retreat his Knight, his drawing chances vanish.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 49,
        moveFrom: 'b7',
        moveTo: 'b5',
        fen: '3r2k1/p4ppp/3B4/1p1P4/2N5/3n1P2/P5PP/3R2K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 50,
        moveFrom: 'c4',
        moveTo: 'e5',
        fen: '3r2k1/p4ppp/3B4/1p1PN3/8/3n1P2/P5PP/3R2K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 51,
        moveFrom: 'd8',
        moveTo: 'd6',
        fen: '6k1/p4ppp/3r4/1p1PN3/8/3n1P2/P5PP/3R2K1',
        comment: '',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 52,
        moveFrom: 'd1',
        moveTo: 'd3',
        fen: '6k1/p4ppp/3r4/1p1PN3/8/3R1P2/P5PP/6K1',
        comment: 'The exchange of minor pieces only helps me.',
        isBestMoment: true,
        isPredictionRight: false,
      },
      {
        id: 53,
        moveFrom: 'a7',
        moveTo: 'a5',
        fen: '6k1/5ppp/3r4/pp1PN3/8/3R1P2/P5PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 54,
        moveFrom: 'e5',
        moveTo: 'c6',
        fen: '6k1/5ppp/2Nr4/pp1P4/8/3R1P2/P5PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 55,
        moveFrom: 'a5',
        moveTo: 'a4',
        fen: '6k1/5ppp/2Nr4/1p1P4/p7/3R1P2/P5PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 56,
        moveFrom: 'a2',
        moveTo: 'a3',
        fen: '6k1/5ppp/2Nr4/1p1P4/p7/P2R1P2/6PP/6K1',
        comment: "Black's Queen-side Pawns are now frozen and primed to fall.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 57,
        moveFrom: 'b5',
        moveTo: 'b4',
        fen: '6k1/5ppp/2Nr4/3P4/pp6/P2R1P2/6PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 58,
        moveFrom: 'c6',
        moveTo: 'b4',
        fen: '6k1/5ppp/3r4/3P4/pN6/P2R1P2/6PP/6K1',
        comment: "Now I have to move Black's Rook out of the way to advance my passed Pawn.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 59,
        moveFrom: 'h7',
        moveTo: 'h5',
        fen: '6k1/5pp1/3r4/3P3p/pN6/P2R1P2/6PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 60,
        moveFrom: 'b4',
        moveTo: 'a2',
        fen: '6k1/5pp1/3r4/3P3p/p7/P2R1P2/N5PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 61,
        moveFrom: 'f7',
        moveTo: 'f5',
        fen: '6k1/6p1/3r4/3P1p1p/p7/P2R1P2/N5PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 62,
        moveFrom: 'a2',
        moveTo: 'c3',
        fen: '6k1/6p1/3r4/3P1p1p/p7/P1NR1P2/6PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 63,
        moveFrom: 'g7',
        moveTo: 'g5',
        fen: '6k1/8/3r4/3P1ppp/p7/P1NR1P2/6PP/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 64,
        moveFrom: 'g2',
        moveTo: 'g3',
        fen: '6k1/8/3r4/3P1ppp/p7/P1NR1PP1/7P/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 65,
        moveFrom: 'h5',
        moveTo: 'h4',
        fen: '6k1/8/3r4/3P1pp1/p6p/P1NR1PP1/7P/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 66,
        moveFrom: 'c3',
        moveTo: 'a4',
        fen: '6k1/8/3r4/3P1pp1/N6p/P2R1PP1/7P/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 67,
        moveFrom: 'h4',
        moveTo: 'g3',
        fen: '6k1/8/3r4/3P1pp1/N7/P2R1Pp1/7P/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 68,
        moveFrom: 'h2',
        moveTo: 'g3',
        fen: '6k1/8/3r4/3P1pp1/N7/P2R1PP1/8/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 69,
        moveFrom: 'g8',
        moveTo: 'f7',
        fen: '8/5k2/3r4/3P1pp1/N7/P2R1PP1/8/6K1',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 70,
        moveFrom: 'g1',
        moveTo: 'f2',
        fen: '8/5k2/3r4/3P1pp1/N7/P2R1PP1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 71,
        moveFrom: 'f7',
        moveTo: 'g6',
        fen: '8/8/3r2k1/3P1pp1/N7/P2R1PP1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 72,
        moveFrom: 'a4',
        moveTo: 'b2',
        fen: '8/8/3r2k1/3P1pp1/8/P2R1PP1/1N3K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 73,
        moveFrom: 'g6',
        moveTo: 'h5',
        fen: '8/8/3r4/3P1ppk/8/P2R1PP1/1N3K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 74,
        moveFrom: 'b2',
        moveTo: 'c4',
        fen: '8/8/3r4/3P1ppk/2N5/P2R1PP1/5K2/8',
        comment: 'After some time-wasting on the King-side, I put my plan into action.',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 75,
        moveFrom: 'd6',
        moveTo: 'd7',
        fen: '8/3r4/8/3P1ppk/2N5/P2R1PP1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 76,
        moveFrom: 'd5',
        moveTo: 'd6',
        fen: '8/3r4/3P4/5ppk/2N5/P2R1PP1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 77,
        moveFrom: 'd7',
        moveTo: 'd8',
        fen: '3r4/8/3P4/5ppk/2N5/P2R1PP1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 78,
        moveFrom: 'd6',
        moveTo: 'd7',
        fen: '3r4/3P4/8/5ppk/2N5/P2R1PP1/5K2/8',
        comment:
          "I was shocked when Black didn't resign here. He wants to play it out to the mate.",
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 79,
        moveFrom: 'g5',
        moveTo: 'g4',
        fen: '3r4/3P4/8/5p1k/2N3p1/P2R1PP1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 80,
        moveFrom: 'f3',
        moveTo: 'f4',
        fen: '3r4/3P4/8/5p1k/2N2Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 81,
        moveFrom: 'h5',
        moveTo: 'g6',
        fen: '3r4/3P4/6k1/5p2/2N2Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 82,
        moveFrom: 'c4',
        moveTo: 'e5',
        fen: '3r4/3P4/6k1/4Np2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 83,
        moveFrom: 'g6',
        moveTo: 'f6',
        fen: '3r4/3P4/5k2/4Np2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 84,
        moveFrom: 'e5',
        moveTo: 'c6',
        fen: '3r4/3P4/2N2k2/5p2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 85,
        moveFrom: 'd8',
        moveTo: 'c8',
        fen: '2r5/3P4/2N2k2/5p2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 86,
        moveFrom: 'd7',
        moveTo: 'c8q',
        fen: '2Q5/8/2N2k2/5p2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 87,
        moveFrom: 'f6',
        moveTo: 'g7',
        fen: '2Q5/6k1/2N5/5p2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 88,
        moveFrom: 'c8',
        moveTo: 'e6',
        fen: '8/6k1/2N1Q3/5p2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 89,
        moveFrom: 'g7',
        moveTo: 'h8',
        fen: '7k/8/2N1Q3/5p2/5Pp1/P2R2P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 90,
        moveFrom: 'd3',
        moveTo: 'd8',
        fen: '3R3k/8/2N1Q3/5p2/5Pp1/P5P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 91,
        moveFrom: 'h8',
        moveTo: 'g7',
        fen: '3R4/6k1/2N1Q3/5p2/5Pp1/P5P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 92,
        moveFrom: 'd8',
        moveTo: 'd7',
        fen: '8/3R2k1/2N1Q3/5p2/5Pp1/P5P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 93,
        moveFrom: 'g7',
        moveTo: 'f8',
        fen: '5k2/3R4/2N1Q3/5p2/5Pp1/P5P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 94,
        moveFrom: 'e6',
        moveTo: 'f6',
        fen: '5k2/3R4/2N2Q2/5p2/5Pp1/P5P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 95,
        moveFrom: 'f8',
        moveTo: 'e8',
        fen: '4k3/3R4/2N2Q2/5p2/5Pp1/P5P1/5K2/8',
        comment: '',
        isBestMoment: false,
        isPredictionRight: true,
      },
      {
        id: 96,
        moveFrom: 'f6',
        moveTo: 'e7',
        fen: '4k3/3RQ3/2N5/5p2/5Pp1/P5P1/5K2/8',
        comment: 'I oblige him.',
        isBestMoment: false,
        isPredictionRight: true,
      },
    ],
  },
];
